const cs = {
  'common.loading': 'Načítání…',
  'common.save': 'Uložit',
  'common.saving': 'Ukládání…',
  'common.cancel': 'Zrušit',
  'common.delete': 'Smazat',
  'common.search': 'Hledat',
  'common.sortBy': 'Řadit podle',
  'common.never': 'Nikdy',
  'common.justNow': 'Právě teď',
  'common.accessDenied': 'Přístup odepřen',
  'common.backToLogin': 'Zpět na přihlášení',
  'common.markAsRead': 'Označit jako přečtené',
  'common.user': 'Uživatel',
  'shell.supportDesk': 'Centrum podpory',
  'shell.searchPlaceholder': 'Hledat tikety, kontakty, články…',
  'shell.newTicket': 'Nový tiket',
  'shell.notifications': 'Oznámení',
  'shell.notificationPreferences': 'Nastavení oznámení',
  'shell.settings': 'Nastavení',
  'shell.signOut': 'Odhlásit se',
  'shell.expandNavigation': 'Rozbalit navigaci',
  'shell.collapseNavigation': 'Sbalit navigaci',
  'shell.adminNavigation': 'Navigace administrace',
  'shell.caughtUp': 'Vše je vyřízeno',
  'shell.viewAllNotifications': 'Zobrazit všechna oznámení',
  'nav.dashboard': 'Přehled',
  'nav.tickets': 'Tikety',
  'nav.contacts': 'Kontakty',
  'nav.companies': 'Společnosti',
  'nav.reports': 'Reporty',
  'nav.settings': 'Nastavení',
  'nav.agents': 'Agenti',
  'nav.groups': 'Skupiny',
  'nav.roles': 'Role',
  'nav.tags': 'Štítky',
  'nav.ticketFields': 'Pole tiketu',
  'nav.ticketForms': 'Formuláře tiketů',
  'nav.businessHours': 'Pracovní doba',
  'nav.slaPolicies': 'Pravidla SLA',
  'nav.automations': 'Automatizace',
  'nav.email': 'E-mail',
  'nav.notificationTemplates': 'Šablony oznámení',
  'nav.apiKeys': 'Klíče API',
  'nav.cannedResponses': 'Předpřipravené odpovědi',
  'nav.knowledgeBase': 'Znalostní báze',
  'auth.signInTitle': 'Podpora SDPL',
  'auth.signInSubtitle': 'Přihlaste se ke svému účtu',
  'auth.emailAddress': 'E-mailová adresa',
  'auth.password': 'Heslo',
  'auth.signingIn': 'Přihlašování…',
  'auth.signIn': 'Přihlásit se',
  'auth.forgotPassword': 'Zapomněli jste heslo?',
  'auth.twoFactor': 'Dvoufaktorové ověřování',
  'auth.verificationCode': 'Ověřovací kód',
  'auth.verify': 'Ověřit',
  'auth.backToLogin': 'Zpět na přihlášení',
  'agents.title': 'Agenti',
  'agents.new': 'Nový agent',
  'agents.supportAgents': 'Agenti podpory',
  'agents.collaborators': 'Spolupracovníci',
  'agents.deactivated': 'Deaktivovaní',
  'agents.searchPlaceholder': 'Hledat podle jména nebo e-mailu',
  'agents.noSearchResults': 'Tomuto hledání neodpovídají žádní agenti',
  'agents.noAgentsView': 'V tomto zobrazení nejsou žádní agenti',
  'agents.edit': 'Upravit',
  'agents.deactivate': 'Deaktivovat',
  'agents.reactivate': 'Znovu aktivovat',
  'agents.saved': 'Agent byl uložen.',
  'agents.firstName': 'Jméno',
  'agents.lastName': 'Příjmení',
  'agents.email': 'E-mail',
  'agents.phone': 'Telefon',
  'agents.timezone': 'Časové pásmo',
  'agents.selectTimezone': 'Vyberte časové pásmo',
  'agents.language': 'Jazyk',
  'agents.selectLanguage': 'Vyberte jazyk',
  'agents.emailSignature': 'E-mailový podpis',
  'agents.roleRequired': 'Role',
  'agents.selectRole': 'Vyberte roli',
  'agents.status': 'Stav',
  'agents.groupsTitle': 'Skupiny',
  'agents.manageGroups': 'Spravovat skupiny',
  'agents.notInGroup': 'Zatím není v žádné skupině',
  'dashboard.title': 'Přehled',
  'dashboard.description': 'Aktuální pracovní zatížení podpory a stav služeb.',
  'dashboard.allGroups': 'Všechny dostupné skupiny',
  'dashboard.unresolved': 'Nevyřešené',
  'dashboard.overdue': 'Po termínu',
  'dashboard.dueToday': 'Splatné dnes',
  'dashboard.open': 'Otevřené',
  'dashboard.onHold': 'Pozastavené',
  'dashboard.unassigned': 'Nepřiřazené',
  'dashboard.trends': 'Dnešní trendy',
  'dashboard.today': 'Dnes',
  'dashboard.yesterday': 'Včera',
  'notifications.title': 'Oznámení',
  'notifications.description': 'Celá historie vašich oznámení.',
  'notifications.markAllRead': 'Označit vše jako přečtené',
  'notifications.filter': 'Filtr',
  'notifications.allTypes': 'Všechny typy',
  'notifications.none': 'Zatím žádná oznámení',
  'notifications.assigned': 'Přiřazení',
  'notifications.reply': 'Odpověď',
  'notifications.note': 'Poznámka',
  'notifications.slaWarning': 'Upozornění SLA',
  'notifications.slaBreach': 'Porušení SLA',
  'notifications.slaEscalation': 'Eskalace SLA',
  'notifications.mention': 'Zmínka',
  'preferences.title': 'Nastavení oznámení',
  'preferences.description': 'Oznámení v aplikaci zůstávají zapnutá. Vyberte, která z nich mají také posílat e-mail.',
  'preferences.emailDigest': 'E-mailový přehled',
  'preferences.dailySummary': 'Jeden souhrnný e-mail denně místo e-mailu pro každou událost.',
  'preferences.digestOff': 'Vypnuto — e-mail pro každou událost',
  'preferences.digestDaily': 'Denní přehled',
  'preferences.emailNotifications': 'E-mailová oznámení',
  'activities.button': 'Nedávné aktivity',
  'activities.title': 'Nedávné aktivity',
  'activities.loadError': 'Nedávné aktivity se nepodařilo načíst.',
  'activities.systemActor': 'Systém',
  'activities.noneTitle': 'Zatím žádná nedávná aktivita',
  'activities.noneDescription': 'Aktualizace tiketů od vás a vaší skupiny se zde zobrazí, jakmile nastanou.',
  'tickets.title': 'Tikety',
  'tickets.description': 'Všechny tikety, ke kterým máte přístup, filtrované a seřazené podle vašich potřeb.',
  'tickets.dueDateTabs': 'Termín tiketu',
  'tickets.tabAll': 'Všechny tikety',
  'tickets.tabDueToday': 'Termín dnes',
  'tickets.tabOverdue': 'Po termínu',
  'tickets.tabDueTomorrow': 'Termín zítra',
  'tickets.searchPlaceholder': 'Hledat tikety…',
  'tickets.searchAria': 'Hledat tikety',
  'tickets.filters': 'Filtry',
  'tickets.filtersWithCount': 'Filtry ({count})',
  'tickets.sortAria': 'Seřadit tikety podle',
  'tickets.sortTrigger': 'Seřadit: {label}',
  'tickets.sortDateCreated': 'Datum vytvoření',
  'tickets.sortDateUpdated': 'Datum aktualizace',
  'tickets.sortPriority': 'Priorita',
  'tickets.sortStatus': 'Stav',
  'tickets.sortDueDate': 'Termín',
  'tickets.sortAscending': 'Seřadit vzestupně',
  'tickets.sortDescending': 'Seřadit sestupně',
  'tickets.ascending': 'Vzestupně',
  'tickets.descending': 'Sestupně',
  'tickets.layoutAria': 'Rozvržení řádků',
  'tickets.layoutTrigger': 'Rozvržení: {label}',
  'tickets.layoutCard': 'Karta',
  'tickets.layoutInbox': 'Doručená pošta',
  'tickets.layoutTable': 'Tabulka',
  'tickets.export': 'Exportovat',
  'tickets.exportSelected': 'Exportovat vybrané',
  'tickets.selectedCount': 'Vybráno: {count}',
  'tickets.assignAgent': 'Přiřadit agenta',
  'tickets.closeAll': 'Uzavřít vše',
  'tickets.clearSelection': 'Zrušit výběr',
  'tickets.selectAgentPlaceholder': 'Vyberte agenta...',
  'tickets.assignTo': 'Přiřadit k',
  'tickets.assign': 'Přiřadit',
  'tickets.loadFailed': 'Tikety se nepodařilo načíst. Zkuste to znovu.',
  'tickets.bulkCloseFailed': 'Vybrané tikety se nepodařilo uzavřít. Zkuste to znovu.',
  'tickets.bulkAssignFailed': 'Vybrané tikety se nepodařilo přiřadit. Zkuste to znovu.',
  'tickets.noFilterMatchTitle': 'Těmto filtrům neodpovídá žádný tiket',
  'tickets.noFilterMatchDescription': 'Zkuste odstranit filtr, rozšířit časové rozpětí nebo hledat jiný výraz.',
  'tickets.clearFilters': 'Vymazat filtry',
  'tickets.queueClearTitle': 'Tato fronta je prázdná',
  'tickets.queueClearDescription': 'Nové tikety se zde zobrazí, jakmile zákazník napíše e-mail, použije portál nebo agent tiket vytvoří.',
  'tickets.newTicket': 'Nový tiket',
  'tickets.selectAllAria': 'Vybrat všechny tikety',
  'tickets.selectTicketAria': 'Vybrat tiket č. {number}',
  'tickets.columnContact': 'Kontakt',
  'tickets.columnSubject': 'Předmět',
  'tickets.columnState': 'Stav',
  'tickets.columnGroup': 'Skupina',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Priorita',
  'tickets.noGroup': 'Žádná skupina',
  'tickets.unassigned': 'Nepřiřazeno',
  'tickets.createdRelative': 'Vytvořeno {when}',
  'tickets.unassignedOnly': 'Pouze nepřiřazené',
  'tickets.unknownRequester': 'Neznámý žadatel',
  'tickets.overdueBy': 'Po termínu o {duration}',
  'tickets.dueIn': 'Termín za {duration}',
  'tickets.filtersDrawerTitle': 'Filtry',
  'tickets.filtersSearchPlaceholder': 'Hledat pole',
  'tickets.filtersSearchAria': 'Hledat pole filtru',
  'tickets.filtersClearAll': 'Vymazat vše',
  'tickets.filtersApply': 'Použít',
  'tickets.filterAgents': 'Agenti',
  'tickets.filterAnyAgent': 'Kterýkoli agent',
  'tickets.filterGroups': 'Skupiny',
  'tickets.filterAnyGroup': 'Kterákoli skupina',
  'tickets.filterStatus': 'Stav',
  'tickets.filterAnyStatus': 'Kterýkoli stav',
  'tickets.filterPriority': 'Priorita',
  'tickets.filterAnyPriority': 'Kterákoli priorita',
  'tickets.filterSource': 'Zdroj',
  'tickets.filterAnySource': 'Kterýkoli zdroj',
  'tickets.filterTicketType': 'Typ tiketu',
  'tickets.filterAnyType': 'Kterýkoli typ',
  'tickets.filterTags': 'Štítky',
  'tickets.filterAnyTag': 'Kterýkoli štítek',
  'tickets.filterCompanies': 'Společnosti',
  'tickets.filterAnyCompany': 'Kterákoli společnost',
  'tickets.filterCreated': 'Vytvořeno',
  'tickets.filterResolvedAt': 'Vyřešeno',
  'tickets.filterClosedAt': 'Uzavřeno',
  'tickets.filterDateFrom': '{label} od',
  'tickets.filterDateTo': '{label} do',
  'tickets.filterDateTo2': 'do',
  'tickets.filterAny': 'Kterýkoli',
  'tickets.chipFieldStatus': 'Stav',
  'tickets.chipFieldPriority': 'Priorita',
  'tickets.chipFieldGroup': 'Skupina',
  'tickets.chipFieldAssignee': 'Řešitel',
  'tickets.chipValueGroup': 'Skupina',
  'tickets.chipValueUnassigned': 'Nepřiřazeno',
  'common.clearSearch': 'Vymazat hledání',
  'common.name': 'Jméno',
  'common.role': 'Role',
  'common.groups': 'Skupiny',
  'common.tickets': 'Tikety',
  'common.lastSeen': 'Poslední přihlášení',
  'common.actions': 'Akce',
  'common.minutesAgo': 'před {count} min',
  'common.hoursAgo': 'před {count} h',
  'common.daysAgo': 'před {count} d',
  'common.noPagePermission': 'Nemáte oprávnění k přístupu na tuto stránku.',
  'common.roleNoPermission': 'Vaše role nemá oprávnění k přístupu na tuto stránku.',
  'common.requestFailed': 'Požadavek se nezdařil. Zkuste to znovu.',
  'common.unexpectedError': 'Došlo k neočekávané chybě',
  'shell.skipToMain': 'Přejít na hlavní obsah',
  'shell.homeLabel': 'Domovská stránka Suzuki Support Desk',
  'shell.userMenu': 'Nabídka uživatele',
  'shell.unread': '{count} nepřečtených',
  'shell.notificationDescription': 'Nová přiřazení, odpovědi a upozornění SLA se zobrazí zde.',
  'auth.enterAuthenticatorCode': 'Zadejte 6místný kód z vaší ověřovací aplikace',
  'auth.verifying': 'Ověřování…',
  'auth.setupAuthenticator': 'Nastavit ověřovací aplikaci',
  'auth.scanAuthenticator': 'Naskenujte tento kód ověřovací aplikací (Google Authenticator, Authy atd.)',
  'auth.authenticatorSetupQr': 'QR kód pro nastavení ověřovací aplikace',
  'auth.verificationCodeFromAuthenticator': 'Ověřovací kód z aplikace',
  'auth.verifyAndComplete': 'Ověřit a dokončit nastavení',
  'auth.loadingSetup': 'Načítání nastavení…',
  'auth.setNewPassword': 'Nastavit nové heslo',
  'auth.temporaryPasswordExpired': 'Vaše dočasné heslo vypršelo. Nastavte prosím nové heslo.',
  'auth.newPassword': 'Nové heslo',
  'auth.confirmPassword': 'Potvrďte heslo',
  'auth.settingPassword': 'Nastavování hesla…',
  'auth.setPassword': 'Nastavit heslo',
  'auth.passwordRequirements': 'Vyžadováno alespoň 8 znaků, velké a malé písmeno, číslo a symbol',
  'auth.tooManyAttempts': 'Příliš mnoho pokusů o přihlášení. Zkuste to prosím později.',
  'auth.invalidCredentials': 'Neplatný e-mail nebo heslo',
  'auth.passwordsDoNotMatch': 'Hesla se neshodují',
  'auth.passwordMinimum': 'Heslo musí mít alespoň {count} znaků',
  'auth.resetTitle': 'Resetujte své heslo',
  'auth.resetSubtitle': 'Zadejte svůj e-mail a my vám zašleme odkaz pro obnovení',
  'auth.checkEmail': 'Zkontrolujte svůj e-mail a odkaz pro obnovení',
  'auth.checkCode': 'Zkontrolujte svůj e-mail pro ověřovací kód a poté pokračujte níže.',
  'auth.continueToReset': 'Pokračovat k obnovení hesla',
  'auth.sendResetLink': 'Odeslat odkaz pro obnovení',
  'auth.sending': 'Odesílání…',
  'auth.resetSuccess': 'Vaše heslo bylo úspěšně obnoveno.',
  'auth.goToLogin': 'Přejít na přihlášení',
  'auth.missingResetToken': 'Chybí token pro obnovení. Použijte prosím odkaz z e-mailu.',
  'auth.enterCodeFromEmail': 'Zadejte ověřovací kód zaslaný na váš e-mail',
  'auth.codeFromEmail': 'Zadejte kód z e-mailu',
  'auth.emailRequired': 'E-mail je povinný',
  'auth.codeRequired': 'Ověřovací kód je povinný',
  'auth.missingToken': 'Chybí token pro obnovení',
  'auth.failedReset': 'Obnovení hesla se nezdařilo.',
  'auth.resetting': 'Obnovování…',
  'auth.resetPassword': 'Obnovit heslo',
  'auth.looksGood': 'Vyhovuje',
  'auth.needCharacters': 'Je potřeba alespoň {count} znaků',
  'auth.passwordFormat': 'Vyžadováno alespoň {count} znaků, velké a malé písmeno, číslo a symbol',
  'agents.description': 'Lidé, kteří řeší tikety. Přiřaďte roli pro kontrolu toho, co mohou dělat, a skupiny pro kontrolu toho, co vidí.',
  'agents.searchAria': 'Hledat agenty',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agentů',
  'agents.ticketOne': '{count} tiket',
  'agents.ticketMany': '{count} tiketů',
  'agents.noGroups': 'Žádné skupiny',
  'agents.lifecycle': 'Životní cyklus agenta',
  'agents.tryDifferent': 'Zkuste jiné jméno nebo e-mailovou adresu.',
  'agents.useNewAgent': 'Použijte Nový agent k přidání osoby nebo přepněte záložky pro zobrazení dalších agentů.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Žádná role',
  'agents.openTicketsTitle': 'Otevřené tikety aktuálně přiřazené tomuto agentovi',
  'agents.moreActions': 'Další akce pro {name}',
  'agents.confirmDeleteTitle': 'Smazat {name}?',
  'agents.confirmDeleteDescription': 'Tuto akci nelze vrátit zpět. Agenty spojené s tikety nelze smazat; místo toho je deaktivujte.',
  'agents.confirmDeleteLabel': 'Smazat agenta',
  'agents.agentsVsCollaborators': 'Agenti vs. spolupracovníci',
  'agents.agentsVsCollaboratorsBody': 'Agenti podpory řeší tikety denně. Spolupracovníci mají roli spolupracovníka a jsou obvykle odborníky přizvanými k jednotlivým tiketům bez plného přístupu agenta.',
  'agents.deactivateVsDelete': 'Deaktivace vs. smazání',
  'agents.deactivateVsDeleteBody': 'Deaktivace zachová historii a vlastnictví tiketů, ale zablokuje přihlášení. Smazání je trvalé a funguje pouze pokud agent nemá žádné spojené tikety.',
  'agents.newTitle': 'Nový agent',
  'agents.editTitle': 'Upravit agenta',
  'agents.temporaryPassword': 'Dočasné heslo',
  'agents.passwordHelp': 'Alespoň 12 znaků. Agent si to může po přihlášení změnit.',
  'agents.timezoneHelp': 'Každé datum a čas, které tento agent vidí, se zobrazuje v tomto časovém pásmu.',
  'agents.languageHelp': 'Překládá rozhraní pro agenty. Odpovědi na tikety a obsah zákazníků se nepřekládají.',
  'agents.signaturePlaceholder': 'Připojuje se k odchozím odpovědím',
  'agents.roleHelp': 'Určuje, co tento agent může dělat.',
  'agents.manageRoles': 'Spravovat role',
  'agents.activeHelp': 'Aktivní — zrušení zaškrtnutí zablokuje přihlášení bez smazání agenta',
  'agents.groupHelp': 'Přidejte tohoto agenta do skupiny na obrazovce Skupiny, abyste určili, které tikety uvidí.',
  'agents.about': 'O tomto agentovi',
  'agents.aboutBody': 'Jméno, e-mail, telefon, časové pásmo, jazyk a podpis identifikují agenta a personalizují jeho pracovní prostředí. Role určuje, co může dělat; členství ve skupině určuje, které tikety vidí.',
  'dashboard.trendsDescription': 'Vytváření tiketů podle hodiny UTC ve srovnání s včerejškem.',
  'dashboard.chartAria': 'Objem tiketů podle hodiny UTC, dnes ve srovnání s včerejškem',
  'dashboard.dataUnavailable': 'Data přehledu nejsou k dispozici.',
  'dashboard.loadError': 'Nelze načíst data přehledu. Zkuste to znovu.',
  'notifications.noType': 'Žádná oznámení tohoto typu',
  'notifications.allTypesHint': 'Vyberte výše „Všechny typy“, chcete-li zobrazit zbytek historie.',
  'notifications.emptyDescription': 'Přiřazení, odpovědi a upozornění SLA se zobrazí zde. V nastavení oznámení upravte, které z nich vám budou zaslány e-mailem.',
  'preferences.digestWarning': 'Máte zapnutý denní přehled, takže tato nastavení jsou ignorována, dokud jej nevypnete.',
  'preferences.assignedEvent': 'Tiket je vám přiřazen',
  'preferences.replyEvent': 'Na tiket, na kterém jste, přišla odpověď',
  'preferences.noteEvent': 'Byla přidána soukromá poznámka',
  'preferences.slaWarningEvent': 'SLA se blíží svému termínu',
  'preferences.slaBreachEvent': 'SLA bylo porušeno',
  'preferences.slaEscalationEvent': 'SLA eskaluje po termínu',
  'preferences.mentionEvent': 'Byli jste zmíněni na tiketu',

  'ticketDetail.back': 'Zpět',
  'ticketDetail.follow': 'Sledovat',
  'ticketDetail.following': 'Sledováno',
  'ticketDetail.hideActivities': 'Skrýt aktivity',
  'ticketDetail.activitiesButton': 'Aktivity',
  'ticketDetail.attachmentsCount': 'Přílohy ({count})',
  'ticketDetail.threadAria': 'Vlákno tiketu',
  'ticketDetail.conversationsTabLabel': 'Konverzace',
  'ticketDetail.activitiesTabLabel': 'Aktivity',
  'ticketDetail.noRepliesYet': 'Zatím žádné odpovědi',
  'ticketDetail.noRepliesDescription': 'Pomocí editoru níže odpovězte žadateli nebo přidejte interní poznámku.',
  'ticketDetail.privateNote': 'Soukromá poznámka',
  'ticketDetail.forward': 'Přeposláno',
  'ticketDetail.uploadingAria': 'Nahrávání',
  'ticketDetail.uploadingProgress': 'Nahrávání {uploading} z {total} souborů…',
  'ticketDetail.uploadsFailed': '{count} nahrání se nezdařilo',
  'ticketDetail.retry': 'Zkusit znovu',
  'ticketDetail.dismiss': 'Zavřít',
  'ticketDetail.noActivityYet': 'Zatím žádná aktivita',
  'ticketDetail.noActivityDescription': 'Změny stavu, agenta a SLA se zde zobrazí, jak se tiket vyvíjí.',
  'ticketDetail.requester': 'Žadatel',
  'ticketDetail.properties': 'Vlastnosti',
  'ticketDetail.updating': 'Aktualizace…',
  'ticketDetail.update': 'Aktualizovat',
  'ticketDetail.tags': 'Štítky',
  'ticketDetail.relationships': 'Vztahy',
  'ticketDetail.parentTicket': 'Nadřazený tiket',
  'ticketDetail.unlink': 'Odpojit',
  'ticketDetail.noParentTicket': 'Žádný nadřazený tiket',
  'ticketDetail.childTicketsCount': 'Podřízené tikety ({count})',
  'ticketDetail.noChildTickets': 'Žádné podřízené tikety',
  'ticketDetail.findTicket': 'Najít tiket',
  'ticketDetail.ticketSearchPlaceholder': 'Číslo tiketu nebo předmět',
  'ticketDetail.searchButton': 'Hledat',
  'ticketDetail.setParent': 'Nastavit nadřazený',
  'ticketDetail.mergeIntoAction': 'Sloučit do',
  'ticketDetail.splitIntoChild': 'Rozdělit na podřízený tiket',
  'ticketDetail.newTicketSubjectPlaceholder': 'Předmět nového tiketu',
  'ticketDetail.splitButton': 'Rozdělit',
  'ticketDetail.copyAttachments': 'Kopírovat přílohy',
  'ticketDetail.copyConversationHistory': 'Kopírovat historii konverzace',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Pozastaveno',
  'ticketDetail.editButton': 'Upravit',
  'ticketDetail.setResolutionDueDate': 'Nastavit termín vyřešení',
  'ticketDetail.pickDateTime': 'Vybrat datum a čas',
  'ticketDetail.resolutionDueLabel': 'Termín vyřešení',
  'ticketDetail.saveSla': 'Uložit SLA',
  'ticketDetail.savingSla': 'Ukládání…',
  'ticketDetail.noSlaPolicy': 'Na tento tiket není použito žádné pravidlo SLA.',
  'ticketDetail.firstResponse': 'První odpověď',
  'ticketDetail.resolution': 'Vyřešení',
  'ticketDetail.done': 'Hotovo',
  'ticketDetail.pausedSince': 'Pozastaveno od {date}',
  'ticketDetail.escalation': 'Eskalace',
  'ticketDetail.escalatedLevel2': 'Eskalováno (úroveň 2)',
  'ticketDetail.escalated': 'Eskalováno',
  'ticketDetail.dueDateOverridden': 'Termín byl manuálně upraven administrátorem.',
  'ticketDetail.dates': 'Data',
  'ticketDetail.created': 'Vytvořeno',
  'ticketDetail.updated': 'Aktualizováno',
  'ticketDetail.resolved': 'Vyřešeno',
  'ticketDetail.closed': 'Uzavřeno',
  'ticketDetail.loadErrorTitle': 'Tento tiket se nepodařilo načíst',
  'ticketDetail.notFound': 'Tiket nenalezen',
  'ticketDetail.confirmMergeTitle': 'Sloučit tiket č. {source} do č. {target}?',
  'ticketDetail.confirmMergeDescription': 'Aktuální tiket bude uzavřen. Tuto akci nelze vrátit zpět.',
  'ticketDetail.confirmMergeLabel': 'Sloučit tiket',
  'ticketDetail.updateSuccess': 'Tiket aktualizován',
  'ticketDetail.updateError': 'Nelze aktualizovat tiket',
  'ticketDetail.pickDateTitle': 'Vyberte datum',
  'ticketDetail.pickDateDescription': 'Vyberte termín vyřešení.',
  'ticketDetail.slaUpdateSuccess': 'SLA aktualizováno',
  'ticketDetail.slaUpdateError': 'Nelze aktualizovat SLA',
  'ticketDetail.searchError': 'Nelze hledat tikety',
  'ticketDetail.parentUpdateError': 'Nelze aktualizovat nadřazený tiket',
  'ticketDetail.mergeSuccess': 'Sloučeno do č. {number}',
  'ticketDetail.mergeError': 'Nelze sloučit tiket',
  'ticketDetail.splitSuccess': 'Rozdělení tiketu vytvořeno',
  'ticketDetail.splitError': 'Nelze rozdělit tiket',
  'ticketDetail.downloadError': 'Nelze stáhnout přílohu',
  'ticketDetail.followSuccess': 'Nyní sledujete tiket',
  'ticketDetail.unfollowSuccess': 'Sledování tiketu zastaveno',
  'ticketDetail.watcherError': 'Nelze aktualizovat stav sledování',
  'ticketDetail.fieldsLoadError': 'Nelze načíst pole tiketu',
  'ticketDetail.overdueBy': 'Po termínu o {label}',
  'ticketDetail.dueLeft': 'Zbývá {label}',
  'ticketDetail.presetToday': 'Dnes',
  'ticketDetail.presetTomorrow': 'Zítra',
  'ticketDetail.presetThisWeek': 'Tento týden',
  'ticketDetail.presetNextWeek': 'Příští týden',
  'ticketDetail.presetThisMonth': 'Tento měsíc',
  'ticketDetail.eventTicketCreated': 'Tiket vytvořen',
  'ticketDetail.eventStatusUpdated': 'Stav aktualizován',
  'ticketDetail.eventAgentUpdated': 'Agent aktualizován',
  'ticketDetail.eventSlaUpdated': 'SLA aktualizováno',
  'ticketDetail.eventTicketMerged': 'Tiket sloučen',
  'ticketDetail.eventMergeReceived': 'Přijato sloučení',
  'ticketDetail.eventTicketSplit': 'Tiket rozdělen',
  'ticketDetail.eventUpdated': 'Aktualizováno',
  'ticketDetail.eventSplitContentCopied': 'Rozdělený obsah zkopírován',
  'ticketDetail.eventReplySent': 'Odpověď odeslána',
  'ticketDetail.eventNoteAdded': 'Poznámka přidána',
  'ticketDetail.eventCustomerReplied': 'Zákazník odpověděl',
  'ticketDetail.eventTicketDeleted': 'Tiket smazán',
  'preferences.createdEvent': 'Ticket byl vytvořen',
  'preferences.pendingInputEvent': 'Ticket čeká na vaši odpověď',
  'preferences.resolvedEvent': 'Ticket byl vyřešen',
  'agents.assignGroups': 'Přiřadit skupiny',
  'agents.assignGroupsHelp': 'Členství ve skupinách určuje, které tickety agent uvidí.',
  'agents.selectGroups': 'Vyberte skupiny',
  'agents.ticketVisibility': 'Viditelnost ticketů',
  'agents.ticketVisibilityHelp': 'Zvolte užší hranici pro agenta nebo převezměte výchozí nastavení role. Oprávnění role stále určují, co může agent dělat.',
  'agents.scopeRoleDefault': 'Použít výchozí nastavení role',
  'agents.scopeRoleDefaultHelp': 'Převzít výchozí viditelnost nastavenou pro tuto roli.',
  'agents.scopeAll': 'Všechny tickety',
  'agents.scopeAllHelp': 'Zobrazit všechny nesmazané tickety v tomto účtu.',
  'agents.scopeGroup': 'Tickety ve skupině',
  'agents.scopeGroupHelp': 'Zobrazit tickety přiřazené skupinám, do kterých agent patří.',
  'agents.scopeAssigned': 'Přiřazené tickety',
  'agents.scopeAssignedHelp': 'Zobrazit tickety přiřazené přímo tomuto agentovi.',
  'agents.scopeCollaboratorHelp': 'Spolupracovníci zůstávají omezeni na tickety ve svých skupinách L1.',
  'nav.jira': 'Integrace Jira',
  'notifications.groupAssigned': 'Přiřazení skupině',
  'notifications.groupMemberAdded': 'Přidání do skupiny',
  'preferences.groupAssignedEvent': 'Tiket je přiřazen jedné z vašich skupin',
  'preferences.groupMemberAddedEvent': 'Byli jste přidáni do skupiny podpory',
  'ui.select': 'Vyberte…',
  'ui.any': 'Jakýkoli',
  'ui.typeToSearch': 'Pište pro vyhledání…',
  'ui.noResults': 'Nenalezeny žádné výsledky',
  'ui.clearSelection': 'Zrušit výběr',
  'ui.removeItem': 'Odebrat {label}',
  'ui.pressEnterToUse': 'Stisknutím klávesy Enter použijete tuto hodnotu',
  'ui.removeFilter': 'Odebrat filtr {field}: {value}',
  'ui.removeTag': 'Odebrat štítek {label}',
  'ui.retry': 'Zkusit znovu',
  'ui.errorTitle': 'Tento obsah se nepodařilo načíst',
  'ui.errorMessage': 'Zkontrolujte připojení a zkuste to znovu.',
  'ui.reference': 'Reference: {id}',
  'ui.thisArea': 'tato oblast',
  'ui.noAccess': 'Nemáte přístup k oblasti {area}',
  'ui.noAccessHint': 'Požádejte správce o udělení potřebného oprávnění.',
  'ui.actionFailed': 'Tuto akci se nepodařilo dokončit. Zkuste to znovu.',
  'ui.slaPaused': 'SLA pozastaveno',
  'ui.filteredEmptyTitle': 'Těmto filtrům neodpovídají žádné tikety',
  'ui.filteredEmptyDescription': 'Zkuste odebrat filtr nebo rozšířit časové období.',
  'ui.clearFilters': 'Zrušit filtry',
  'pagination.noResults': 'Žádné výsledky',
  'pagination.showing': 'Zobrazeno {first}–{last} z {total}',
  'pagination.resultsPerPage': 'Výsledků na stránku',
  'pagination.perPage': '{count} na stránku',
  'pagination.previous': 'Předchozí',
  'pagination.next': 'Další',
  'pagination.previousAria': 'Předchozí stránka',
  'pagination.nextAria': 'Další stránka',
  'pagination.pageOf': 'Stránka {page} z {total}',
  'status.open': 'Otevřený',
  'status.to_be_prioritised': 'K prioritizaci',
  'status.work_in_progress': 'Řeší se',
  'status.assigned_to_ai_agent': 'Přiřazeno AI agentovi',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Čeká se',
  'status.awaiting_user_reply': 'Čeká na odpověď uživatele',
  'status.awaiting_resolution_confirmation': 'Čeká na potvrzení vyřešení',
  'status.on_hold': 'Pozastaveno',
  'status.pending_production_release': 'Čeká na nasazení do produkce',
  'status.product_cr': 'Produktový CR',
  'status.reopened': 'Znovu otevřeno',
  'status.issue_fixed': 'Problém opraven',
  'status.resolved': 'Vyřešeno',
  'status.closed': 'Uzavřeno',
  'status.unknown': 'Neznámý',
  'priority.low': 'Nízká',
  'priority.medium': 'Střední',
  'priority.high': 'Vysoká',
  'priority.urgent': 'Naléhavá',
  'source.email': 'E-mail',
  'source.portal': 'Portál',
  'source.phone': 'Telefon',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Webový chat',
  'source.web_form': 'Webový formulář',
  'source.forum': 'Fórum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget zpětné vazby',
  'source.outbound_email': 'Odchozí e-mail',
  'source.ecommerce': 'E-commerce',
  'source.bot': 'Bot',
  'source.instagram_message': 'Zpráva na Instagramu',
  'source.instagram_comment': 'Komentář na Instagramu',
  'source.facebook_message': 'Zpráva na Facebooku',
  'source.facebook_comment': 'Komentář na Facebooku',
  'source.mobile_chat_sdk': 'Mobile Chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Uložená zobrazení',
  'savedViews.saveCurrent': 'Uložit aktuální filtry jako zobrazení',
  'savedViews.namePlaceholder': 'Název zobrazení...',
  'savedViews.nameAria': 'Název zobrazení',
  'savedViews.empty': 'Žádná uložená zobrazení. Použijte filtry a uložte je zde.',
  'savedViews.listAria': 'Seznam uložených zobrazení',
  'savedViews.rename': 'Přejmenovat zobrazení „{name}“',
  'savedViews.delete': 'Smazat zobrazení „{name}“',
  'export.title': 'Exportovat tikety',
  'export.loadError': 'Seznam polí pro export se nepodařilo načíst.',
  'export.failed': 'Export se nezdařil. Zkuste to prosím znovu.',
  'export.pdfFailed': 'Export do PDF se nezdařil. Zkuste to prosím znovu.',
  'export.fieldsSelectedOne': 'Vybráno {count} pole',
  'export.fieldsSelectedMany': 'Vybráno polí: {count}',
  'export.fieldsTotalOne': 'Celkem {count} pole',
  'export.fieldsTotalMany': 'Celkem polí: {count}',
  'export.selectAllFields': 'Vybrat všechna pole',
  'export.exportingOne': 'Exportuje se 1 vybraný tiket.',
  'export.exportingMany': 'Exportuje se vybraných tiketů: {count}.',
  'export.pdfZip': 'Stáhnout jako PDF (.zip, souborů: {count})',
  'export.pdf': 'Stáhnout jako PDF',
  'export.pdfZipHint': 'Vytvoří jedno PDF pro každý tiket a zabalí je do jednoho souboru ZIP ke stažení.',
  'export.pdfHint': 'Vytvoří jedno PDF s vlastnostmi tiketu a veřejnou konverzací.',
  'export.formatLabel': 'Exportovat jako (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Načítání seznamu polí…',
  'export.ticketFields': 'Pole tiketu',
  'export.contactFields': 'Pole kontaktu',
  'export.companyFields': 'Pole společnosti',
  'export.exporting': 'Exportuje se…',
  'newTicket.title': 'Vytvořit tiket',
  'newTicket.description': 'Vyberte uložený formulář a vyplňte jeho pole.',
  'newTicket.form': 'Formulář tiketu',
  'newTicket.noForms': 'Nejsou k dispozici žádné formuláře tiketů. Před vytvořením tiketu nakonfigurujte formulář.',
  'newTicket.loadFormsError': 'Formuláře tiketů se nepodařilo načíst',
  'newTicket.loadFormError': 'Vybraný formulář tiketu se nepodařilo načíst',
  'newTicket.addCc': 'Přidat kopii',
  'newTicket.cc': 'Kopie',
  'newTicket.removeFile': 'Odebrat {name}',
  'newTicket.requesterRequired': 'Žadatel je povinný',
  'newTicket.subjectRequired': 'Předmět je povinný',
  'newTicket.createFailed': 'Tiket se nepodařilo vytvořit',
  'newTicket.noFormTitle': 'Není k dispozici žádný formulář tiketu',
  'newTicket.noFormDescription': 'Vytvořte formulář tiketu v Nastavení a poté se vraťte a otevřete tiket.',
  'newTicket.noFieldsTitle': 'Tento formulář zatím nemá žádná pole',
  'newTicket.noFieldsDescription': 'Přidejte pole do formuláře v Nastavení a poté stránku znovu načtěte.',
  'newTicket.creating': 'Vytváření...',
  'newTicket.submit': 'Vytvořit tiket',
  'fields.required': 'Pole {label} je povinné',
  'fields.selectParentFirst': 'Nejprve vyberte nadřazenou hodnotu...',
  'fields.selectPlaceholder': 'Vyberte: {label}...',
  'fields.enterPlaceholder': 'Zadejte: {label}...',
  'fields.optionsLoadError': 'Možnosti pro {label} se nepodařilo načíst',
  'fields.label.requester': 'Žadatel',
  'fields.label.subject': 'Předmět',
  'fields.label.description': 'Popis',
  'fields.label.status': 'Stav',
  'fields.label.priority': 'Priorita',
  'fields.label.source': 'Zdroj',
  'fields.label.ticket_type': 'Typ',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Skupina',
  'fields.label.internal_agent': 'Interní agent',
  'fields.label.internal_group': 'Interní skupina',
  'fields.label.company': 'Společnost',
  'editor.defaultPlaceholder': 'Pište zde...',
  'editor.ariaLabel': 'Editor formátovaného textu',
  'editor.toolbarAria': 'Formátování textu',
  'editor.bold': 'Tučně (Ctrl+B)',
  'editor.italic': 'Kurzíva (Ctrl+I)',
  'editor.underline': 'Podtržení (Ctrl+U)',
  'editor.strikethrough': 'Přeškrtnutí',
  'editor.heading1': 'Nadpis 1',
  'editor.heading2': 'Nadpis 2',
  'editor.textColor': 'Barva textu',
  'editor.highlight': 'Zvýraznění',
  'editor.bulletList': 'Odrážkový seznam',
  'editor.numberedList': 'Číslovaný seznam',
  'editor.blockquote': 'Citace',
  'editor.codeBlock': 'Blok kódu',
  'editor.insertLink': 'Vložit odkaz',
  'editor.insertImage': 'Vložit obrázek',
  'editor.insertTable': 'Vložit tabulku',
  'editor.mention': 'Zmínit někoho',
  'editor.undo': 'Zpět (Ctrl+Z)',
  'editor.redo': 'Znovu (Ctrl+Shift+Z)',
  'editor.attach': 'Připojit soubor',
  'editor.noAgents': 'Nenalezeni žádní agenti',
  'editor.mentionSuggestions': 'Návrhy zmínek',
  'editor.dialogLinkTitle': 'Vložit odkaz',
  'editor.dialogImageTitle': 'Vložit obrázek',
  'editor.linkHint': 'Zadejte URL HTTP(S), mailto, kotvu nebo relativní URL.',
  'editor.imageHint': 'Zadejte URL obrázku HTTP(S) nebo relativní URL.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Zadejte platnou URL HTTP(S), mailto, kotvu nebo relativní URL.',
  'editor.invalidImage': 'Zadejte platnou URL obrázku HTTP(S) nebo relativní URL.',
  'editor.selectTextForLink': 'Před přidáním odkazu vyberte text.',
  'editor.imageInsertFailed': 'Obrázek se sem nepodařilo vložit.',
  'editor.insertLinkAction': 'Vložit odkaz',
  'editor.insertImageAction': 'Vložit obrázek',
  'search.dialogAria': 'Globální vyhledávání',
  'search.placeholder': 'Hledat tikety, kontakty...',
  'search.aria': 'Hledat',
  'search.close': 'Zavřít vyhledávání',
  'search.noMatches': 'Žádné shody pro „{query}“',
  'search.noMatchesHint': 'Zkuste číslo tiketu, e-mail kontaktu nebo název společnosti.',
  'search.hintBefore': 'Pro vyhledání zadejte alespoň 2 znaky. Stiskněte',
  'search.hintAfter': 'pro zavření.',

  'td.system': 'Systém',
  'td.actionCreatedTicket': 'vytvořil(a) tiket',
  'td.actionUpdatedFields': 'aktualizoval(a) {fields}',
  'td.fieldStatus': 'stav',
  'td.fieldPriority': 'priorita',
  'td.fieldSource': 'zdroj',
  'td.fieldType': 'typ',
  'td.fieldGroup': 'skupina',
  'td.fieldAgent': 'agent',
  'td.fieldCompany': 'společnost',
  'td.fieldContact': 'kontakt',
  'td.fieldSubject': 'předmět',
  'td.fieldDescription': 'popis',
  'td.fieldProduct': 'produkt',
  'td.fieldResolutionDue': 'termín vyřešení',
  'td.fieldFirstResponseDue': 'termín první odpovědi',
  'td.fieldTags': 'štítky',
  'td.fieldParentTicket': 'nadřazený tiket',
  'td.eventCreated': '{actor} vytvořil(a) nový tiket',
  'td.eventCreatedLinked': '{actor} vytvořil(a) nový tiket a propojil(a) ho s nadřazeným tiketem',
  'td.eventSplit': '{actor} rozdělil(a) tento tiket a vytvořil(a) podřízený tiket{ref}',
  'td.eventMergeReceived': '{actor} sloučil(a) jiný tiket do tohoto tiketu{ref}',
  'td.eventMerged': '{actor} sloučil(a) tento tiket do jiného tiketu{ref}',
  'td.eventSplitCopied': '{actor} zkopíroval(a) {conversations} a {attachments}',
  'td.conversationsOne': '{count} konverzace',
  'td.conversationsMany': '{count} konverzací',
  'td.attachmentsOne': '{count} příloha',
  'td.attachmentsMany': '{count} příloh',
  'td.eventUpdatedFields': '{actor} aktualizoval(a) {fields}',
  'td.invalidSlaState': 'Server vrátil neplatný stav SLA.',
  'td.slaRefreshError': 'Hodiny SLA se nepodařilo obnovit.',
  'td.descriptionUpdated': 'Popis byl aktualizován',
  'td.descriptionUpdateError': 'Popis se nepodařilo aktualizovat',
  'td.descriptionUpdateFailed': 'Aktualizace popisu se nezdařila',
  'td.entryUpdated': 'Záznam byl aktualizován',
  'td.entryUpdateError': 'Záznam se nepodařilo aktualizovat',
  'td.updateFailed': 'Aktualizace se nezdařila',
  'td.loadOlderError': 'Starší konverzace se nepodařilo načíst',
  'td.loadFailed': 'Načtení se nezdařilo',
  'td.slaUpdateFailed': 'Aktualizace SLA se nezdařila',
  'td.reasonTooLong': 'Důvod může mít nejvýše 500 znaků.',
  'td.invalidDateTime': 'Zvolte platné datum a čas.',
  'td.slaDeadlineUpdated': 'Termín SLA byl aktualizován',
  'td.slaConflict': 'Tiket se změnil během úpravy dat SLA. Před dalším pokusem stránku znovu načtěte.',
  'td.slaClearFailed': 'Vymazání SLA se nezdařilo',
  'td.slaTargetCleared': 'Cíl SLA byl vymazán',
  'td.slaClearError': 'Cíl SLA se nepodařilo vymazat',
  'td.noDescription': 'Zatím nebyl přidán žádný popis.',
  'td.editDescriptionAria': 'Upravit popis tiketu',
  'td.download': 'Stáhnout',
  'td.downloadFile': 'Stáhnout {fileName}',
  'td.loadOlder': '↓ +{count} konverzace',
  'td.loadOlderMany': '↓ +{count} konverzací',
  'td.edited': '(upraveno)',
  'td.privateThread': 'Soukromé vlákno',
  'td.propertiesAria': 'Vlastnosti tiketu',
  'td.expandProperties': 'Rozbalit vlastnosti',
  'td.collapseProperties': 'Sbalit vlastnosti',
  'td.metric': 'Metrika',
  'td.firstResponseOption': 'První odpověď',
  'td.resolutionOption': 'Vyřešení',
  'td.overrideHint': 'Nastavte přepsání termínu určené serverem. Důvod se uchová v historii SLA.',
  'td.deadline': 'Termín',
  'td.reasonOptional': 'Důvod (volitelné)',
  'td.reasonPlaceholder': 'Schválená výjimka nebo provozní souvislosti',
  'td.clearResolutionOverride': 'Zrušit přepsání vyřešení',
  'td.clearEscalationTarget': 'Zrušit cíl eskalace',
  'td.toolsAria': 'Nástroje tiketu a kontakt',
  'td.ticketContext': 'Kontext tiketu',
  'td.knowledgeBase': 'Znalostní báze',
  'td.shortcutsAria': 'Zkratky kontextu tiketu',
  'td.showContext': 'Zobrazit kontext tiketu',
  'td.hideContext': 'Skrýt kontext tiketu',
  'td.openRow': 'Otevřít {label}',
  'td.editTicket': 'Upravit tiket',
  'td.searchContactPlaceholder': 'Hledat kontakt…',
  'td.describePlaceholder': 'Popište problém…',
  'td.noAttachments': 'Žádné přílohy',

  'tp.api.csrfUnavailable': 'Nepodařilo se zajistit ochranu CSRF',
  'tp.api.noMfaChallenge': 'Není aktivní žádná výzva MFA',
  'tp.api.noMfaSetup': 'Není aktivní žádná výzva k nastavení MFA',
  'tp.api.noNewPasswordChallenge': 'Není aktivní žádná výzva k zadání nového hesla',
  'tp.articles.isLinkedAria': '{title} je propojen jako řešení',
  'tp.articles.linkAria': 'Propojit {title} jako řešení',
  'tp.articles.linkAsSolution': 'Propojit jako řešení',
  'tp.articles.linkedAsSolution': 'Propojeno jako řešení',
  'tp.articles.none': 'Pro tento tiket nejsou žádné navrhované články.',
  'tp.articles.title': 'Navrhované články',
  'tp.articles.views': 'Zobrazení: {count}',
  'tp.attachment.loadingPreview': 'Načítání náhledu…',
  'tp.attachment.previewUnavailable': 'Náhled není k dispozici',
  'tp.charts.noData': 'Pro toto období nejsou data grafu.',
  'tp.charts.noRecords': 'V tomto období nejsou žádné záznamy.',
  'tp.charts.period': 'Období',
  'tp.charts.showingTop': 'Zobrazeno {shown} nejvyšších z {total} segmentů.',
  'tp.common.cancel': 'Zrušit',
  'tp.common.clear': 'Vymazat',
  'tp.common.loading': 'Načítání…',
  'tp.common.send': 'Odeslat',
  'tp.common.sending': 'Odesílání…',
  'tp.common.system': 'Systém',
  'tp.convActions.edit': 'Upravit',
  'tp.convActions.thread': 'Zahájit vlákno',
  'tp.dashboard.new': 'Nový',
  'tp.dashboard.select': 'Vybrat přehled',
  'tp.forward.failed': 'Přeposlání se nezdařilo',
  'tp.forward.forwarded': 'Tiket byl přeposlán',
  'tp.forward.forwarding': 'Přeposílání…',
  'tp.forward.forwardingMany': 'Přeposílání konverzací: {count}:',
  'tp.forward.forwardingOne': 'Přeposílání 1 konverzace:',
  'tp.forward.message': 'Zpráva',
  'tp.forward.messagePlaceholder': 'Přidejte zprávu (volitelné)…',
  'tp.forward.noContacts': 'Nenalezeny žádné kontakty – zadejte úplnou e-mailovou adresu',
  'tp.forward.recipientEmail': 'E-mail příjemce',
  'tp.forward.recipientInvalid': 'Zadejte platnou e-mailovou adresu příjemce',
  'tp.forward.recipientRequired': 'E-mail příjemce je povinný',
  'tp.forward.searchContact': 'Hledat kontakt nebo zadat e-mail…',
  'tp.forward.title': 'Přeposlat',
  'tp.forward.to': 'Komu',
  'tp.forward.useThisEmail': 'Stisknutím Enter nebo kliknutím na Přeposlat použijete tento e-mail',
  'tp.jira.addOptional': 'Přidat volitelná pole',
  'tp.jira.createAndLink': 'Vytvořit a propojit issue',
  'tp.jira.createIssue': 'Vytvořit issue',
  'tp.jira.createTitle': 'Vytvořit issue v Jira',
  'tp.jira.describePlaceholder': 'Popište problém…',
  'tp.jira.description': 'Popis',
  'tp.jira.development': 'Vývoj',
  'tp.jira.enterDevelopment': 'Zadejte vývoj',
  'tp.jira.hideOptional': 'Skrýt volitelná pole',
  'tp.jira.issueId': 'ID issue',
  'tp.jira.issueSummary': 'Shrnutí issue',
  'tp.jira.issueType': 'Typ issue *',
  'tp.jira.lastSync': 'Poslední synchronizace: {error}',
  'tp.jira.linkIssue': 'Propojit issue',
  'tp.jira.linkTitle': 'Propojit issue v Jira',
  'tp.jira.linkedIssues': 'Propojená issue',
  'tp.jira.linkedIssuesHint': 'Použijte klíče issue z Jira oddělené čárkami.',
  'tp.jira.linkedIssuesPlaceholder': 'např. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Načítání polí Jira…',
  'tp.jira.loadingIssueTypes': 'Načítání typů issue…',
  'tp.jira.loadingProjects': 'Načítání projektů Jira…',
  'tp.jira.loadingUsers': 'Načítání uživatelů Jira…',
  'tp.jira.noLinks': 'K tomuto tiketu zatím nejsou propojena žádná issue z Jira.',
  'tp.jira.noneFound': 'Nenalezena žádná issue v Jira.',
  'tp.jira.notAvailableProject': 'Pro tento projekt není k dispozici',
  'tp.jira.projects': 'Projekty *',
  'tp.jira.refresh': 'Obnovit',
  'tp.jira.refreshFields': 'Obnovit pole Jira',
  'tp.jira.reporter': 'Zadavatel',
  'tp.jira.requestFailed': 'Požadavek na Jira se nezdařil. Zkuste to prosím znovu.',
  'tp.jira.searchBy': 'Hledat podle:',
  'tp.jira.searchIssue': 'Hledat issue',
  'tp.jira.searchIssuePlaceholder': 'Hledat issue…',
  'tp.jira.searchUsers': 'Hledat uživatele Jira',
  'tp.jira.searching': 'Hledání v Jira…',
  'tp.jira.selectIssueType': 'Vyberte typ issue',
  'tp.jira.selectProject': 'Vyberte projekt',
  'tp.jira.summary': 'Shrnutí *',
  'tp.jira.syncOff': 'Synchronizace vypnuta',
  'tp.jira.syncOn': 'Synchronizace zapnuta',
  'tp.jira.syncStatus': 'Synchronizovat stav tiketu do Jira',
  'tp.jira.unassigned': 'Nepřiřazeno',
  'tp.jira.unlink': 'Odpojit',
  'tp.jira.unlinkConfirm': 'Odpojit issue',
  'tp.jira.unlinkDescription': 'Tím se odebere propojení z tiketu, ale issue v Jira se neodstraní.',
  'tp.jira.unlinkTitle': 'Odpojit {key}?',
  'tp.jira.untitled': 'Issue v Jira bez názvu',
  'tp.layout.loadingPage': 'Načítání stránky…',
  'tp.notFound.goToDashboard': 'Přejít na přehled',
  'tp.notFound.title': 'Stránka nenalezena',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Zákazník',
  'tp.reply.addNote': 'Přidat poznámku',
  'tp.reply.attachmentNotAdded': 'Příloha nebyla přidána',
  'tp.reply.clickToExpand': 'Kliknutím rozbalíte',
  'tp.reply.collapsedNote': 'Přidat interní poznámku…',
  'tp.reply.collapsedReply': 'Napsat odpověď nebo poznámku…',
  'tp.reply.conversationType': 'Typ konverzace',
  'tp.reply.failedToSend': 'Odeslání se nezdařilo',
  'tp.reply.markNoteAs': 'Označit poznámku jako',
  'tp.reply.notVisibleToContact': 'Pro kontakt není viditelné',
  'tp.reply.notVisibleToContacts': 'Pro kontakty není viditelné',
  'tp.reply.noteAdded': 'Poznámka byla přidána',
  'tp.reply.notifyTo': 'Oznámit',
  'tp.reply.placeholderPrivateNote': 'Přidat soukromou poznámku...',
  'tp.reply.placeholderPublicNote': 'Přidat veřejnou poznámku viditelnou pro žadatele...',
  'tp.reply.placeholderReply': 'Napište svou odpověď...',
  'tp.reply.private': 'Soukromá',
  'tp.reply.public': 'Veřejná',
  'tp.reply.removeFile': 'Odebrat {name}',
  'tp.reply.replySent': 'Odpověď byla odeslána',
  'tp.reply.searchAgentsToNotify': 'Hledat agenty k oznámení…',
  'tp.reply.sendReply': 'Odeslat odpověď',
  'tp.reply.sending': 'Odesílání...',
  'tp.reply.tabNote': 'Poznámka',
  'tp.reply.tabReply': 'Odpověď',
  'tp.reply.uploadAttachment': 'Nahrát přílohu',
  'tp.reply.visibleToContact': 'Pro kontakt viditelné',
  'tp.reply.visibleToContacts': 'Pro kontakty viditelné',
  'tp.sla.breached': 'Porušeno',
  'tp.sla.cleared': 'Vymazáno',
  'tp.sla.configErrorNoDeadline': 'Chyba konfigurace SLA. Žádný termín není odvozen.',
  'tp.sla.configurationError': 'Chyba konfigurace',
  'tp.sla.couldNotLoad': 'Hodiny SLA se nepodařilo načíst',
  'tp.sla.done': 'Hotovo',
  'tp.sla.dueIn': 'Termín za {duration}',
  'tp.sla.dueLine': 'Termín: {date}',
  'tp.sla.dueNow': 'Termín nyní',
  'tp.sla.escalated': 'Eskalováno',
  'tp.sla.firstResponse': 'První odpověď',
  'tp.sla.invalidDeadline': 'Neplatný termín',
  'tp.sla.mayBeStale': 'Hodiny SLA mohou být neaktuální',
  'tp.sla.noActiveCycle': 'Žádný aktivní cyklus SLA.',
  'tp.sla.noDeadline': 'Bez termínu',
  'tp.sla.noMetrics': 'Pro tento cyklus nejsou k dispozici žádné metriky SLA.',
  'tp.sla.noPolicy': 'Na tento tiket nebylo uplatněno žádné pravidlo SLA.',
  'tp.sla.notConfigured': 'Nenakonfigurováno',
  'tp.sla.notStarted': 'Nezahájeno',
  'tp.sla.overdueBy': 'Po termínu o {duration}',
  'tp.sla.overridden': 'Přepsáno',
  'tp.sla.overrideReason': 'Důvod přepsání: {reason}',
  'tp.sla.paused': 'Pozastaveno',
  'tp.sla.refreshing': 'Obnovování autoritativních hodin SLA…',
  'tp.sla.resolution': 'Vyřešení',
  'tp.sla.stopsSla': 'Zastavuje SLA',
  'tp.thread.empty': 'Zatím nebylo nic odesláno. Vaše první zpráva zahájí toto soukromé vlákno.',
  'tp.thread.messageFailed': 'Zpráva se nezdařila',
  'tp.thread.privateThread': 'Soukromé vlákno',
  'tp.thread.replyPlaceholder': 'Odpovědět ve vlákně…',
  'tp.thread.someone': 'Někdo',
  'tp.thread.startPrivateThread': 'Zahájit soukromé vlákno',
  'tp.thread.startedBy': '{name} zahájil(a) toto vlákno',
  'tp.thread.unableToSend': 'Zprávu se nepodařilo odeslat',
  'tp.ui.breadcrumb': 'Drobečková navigace',
  'tp.ui.closePanel': 'Zavřít panel',
  'tp.ui.dismiss': 'Zavřít {title}',

  'dir.loadError': 'Data se nepodařilo načíst. Zkuste to prosím znovu.',
  'dir.contacts.description': 'Zákaznické kontakty a jejich historie podpory.',
  'dir.contacts.searchAria': 'Hledat kontakty',
  'dir.contacts.count': 'Kontakty: {count}',
  'dir.contacts.noMatch': 'Tomuto hledání neodpovídají žádné kontakty',
  'dir.contacts.none': 'Zatím žádné kontakty',
  'dir.contacts.noneDescription': 'Kontakty se zde zobrazí, jakmile zákazníci začnou odesílat tikety.',
  'dir.company': 'Společnost',
  'dir.unnamedContact': 'Kontakt bez jména',
  'dir.contact': 'Kontakt',
  'dir.contactNotFound': 'Kontakt nebyl nalezen.',
  'dir.confirmDeleteContactTitle': 'Smazat „{name}“?',
  'dir.thisContact': 'tento kontakt',
  'dir.confirmDeleteContactDescription': 'Kontakty s tikety budou deaktivovány místo trvalého smazání.',
  'dir.deleteContact': 'Smazat kontakt',
  'dir.editProfile': 'Upravit profil',
  'dir.profile': 'Profil',
  'dir.firstName': 'Jméno',
  'dir.lastName': 'Příjmení',
  'dir.phone': 'Telefon',
  'dir.timezone': 'Časové pásmo',
  'dir.emailLabel': 'E-mail:',
  'dir.phoneLabel': 'Telefon:',
  'dir.companyLabel': 'Společnost:',
  'dir.timezoneLabel': 'Časové pásmo:',
  'dir.recentTickets': 'Nedávné tikety',
  'dir.noTicketsYet': 'Zatím žádné tikety',
  'dir.contactTicketsDescription': 'Tikety založené tímto kontaktem se zobrazí zde.',
  'dir.ticket': 'Tiket',
  'dir.subject': 'Předmět',
  'dir.status': 'Stav',
  'dir.created': 'Vytvořeno',
  'dir.companies.description': 'Organizace propojené se zákaznickými kontakty a tikety.',
  'dir.companies.add': 'Přidat společnost',
  'dir.companies.domain': 'Doména',
  'dir.companies.create': 'Vytvořit společnost',
  'dir.companies.searchAria': 'Hledat společnosti',
  'dir.companies.searchPlaceholder': 'Hledat společnosti nebo domény',
  'dir.companies.noMatch': 'Tomuto hledání neodpovídají žádné společnosti',
  'dir.companies.addFirst': 'Přidejte svou první společnost',
  'dir.companies.tryDifferent': 'Zkuste jiný název společnosti nebo doménu.',
  'dir.companies.useForm': 'K vytvoření společnosti použijte formulář vedle tohoto seznamu.',
  'dir.companies.contacts': 'Kontakty',
  'dir.companies.tickets': 'Tikety',
  'dir.companies.notFound': 'Společnost nebyla nalezena.',
  'dir.companies.confirmDeleteTitle': 'Smazat „{name}“?',
  'dir.companies.thisCompany': 'tuto společnost',
  'dir.companies.confirmDeleteDescription': 'Společnost nesmí mít žádné kontakty ani tikety, aby ji bylo možné smazat.',
  'dir.companies.delete': 'Smazat společnost',
  'dir.companies.noDomain': 'Není nastavena žádná doména',
  'dir.companies.contactsCount': 'Kontakty ({count})',
  'dir.companies.ticketsCount': 'Tikety ({count})',
  'dir.companies.noContactsDescription': 'Přidejte kontakt a propojte ho s touto společností, aby se zde zobrazil.',
  'dir.companies.noTicketsDescription': 'Tikety založené kontakty této společnosti se zobrazí zde.',
  'dir.trendsCreatedHour': 'Datum vytvoření – hodina dne',
  'dir.reports.loadError': 'Tento report se nepodařilo načíst. Zkuste to prosím znovu.',
  'dir.reports.volume': 'Objem tiketů',
  'dir.reports.sla': 'Dodržování SLA',
  'dir.reports.agents': 'Výkon agentů',
  'dir.reports.csat': 'Spokojenost zákazníků',
  'dir.reports.rca': 'Analýza hlavních příčin',
  'dir.reports.descVolume': 'Zjistěte, odkud tikety přicházejí a jak procházejí životním cyklem.',
  'dir.reports.descSla': 'Sledujte cíle odpovědí a vyřešení napříč dostupným provozem podpory.',
  'dir.reports.descAgents': 'Porovnejte zatížení, výsledky, odpovědi a průměrné doby zpracování podle agenta.',
  'dir.reports.descCsat': 'Čtěte nálady zákazníků, aniž byste zaměňovali objem odpovědí s mírou spokojenosti.',
  'dir.reports.descRca': 'Najděte standardizované hlavní příčiny poptávky po tiketech.',
  'dir.reports.noPayload': 'Pro toto období nebyla vrácena žádná data reportu.',
  'dir.reports.refresh': 'Obnovit',
  'dir.reports.report': 'Report',
  'dir.reports.from': 'Od',
  'dir.reports.to': 'Do',
  'dir.reports.maxRange': 'Maximální rozsah: 90 dní · rozsah odpovídá oprávněním vašeho účtu.',
  'dir.reports.unclassified': 'Nezařazeno',
  'dir.reports.ticketsInPeriod': 'Tikety v období',
  'dir.reports.ticketsInPeriodDetail': 'Dostupné tikety vrácené reportem',
  'dir.reports.created': 'Vytvořeno',
  'dir.reports.createdDetail': 'Napříč zvolenou datovou osou',
  'dir.reports.resolved': 'Vyřešeno',
  'dir.reports.resolvedDetail': '{percent} % vytvořeného objemu',
  'dir.reports.noCreated': 'Žádné vytvořené tikety',
  'dir.reports.reopened': 'Znovu otevřeno',
  'dir.reports.reopenedDetail': 'Události životního cyklu, ne unikátní tikety',
  'dir.reports.dailyPulse': 'Denní puls',
  'dir.reports.volumeByDate': 'Objem tiketů podle data',
  'dir.reports.volumeByDateDescription': 'Řídké záznamy z backendu jsou rozšířeny na úplnou datovou osu doplněnou nulami.',
  'dir.reports.createdTickets': 'Vytvořené tikety',
  'dir.reports.createdVolumeAria': 'Objem vytvořených tiketů podle data',
  'dir.reports.lifecycle': 'Životní cyklus',
  'dir.reports.lifecycleTitle': 'Vytvořeno, vyřešeno, znovu otevřeno',
  'dir.reports.lifecycleDescription': 'Třířádkový pohled na pohyb tiketů životním cyklem.',
  'dir.reports.lifecycleAria': 'Události životního cyklu tiketů podle data',
  'dir.reports.dimensions': 'Dimenze',
  'dir.reports.whereConcentrated': 'Kde je objem soustředěn',
  'dir.reports.topEight': 'V každém panelu je zobrazeno osm nejvyšších segmentů',
  'dir.reports.status': 'Stav',
  'dir.reports.statusDescription': 'Aktuální stav tiketu',
  'dir.reports.priority': 'Priorita',
  'dir.reports.priorityDescription': 'Podíl priorit tiketů',
  'dir.reports.group': 'Skupina',
  'dir.reports.groupDescription': 'Směrovací skupiny',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Přiřazené vlastnictví',
  'dir.reports.product': 'Produkt',
  'dir.reports.productDescription': 'Podíl produktů',
  'dir.reports.country': 'Země',
  'dir.reports.countryDescription': 'Ze standardizovaných polí země',
  'dir.reports.noRecords': 'V tomto období nejsou žádné záznamy.',
  'dir.reports.slaSummary': '{rate} · splněno {met} z {total}',
  'dir.reports.noSlaSegments': 'Zatím žádné segmenty SLA',
  'dir.reports.noSlaSegmentsDescription': 'Pro tuto dimenzi nejsou ve zvoleném období žádné použitelné záznamy SLA.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'První odpověď',
  'dir.reports.resolution': 'Vyřešení',
  'dir.reports.avgFirstResponse': 'Prům. první odpověď',
  'dir.reports.avgResolution': 'Prům. vyřešení',
  'dir.reports.fromTicketMetric': 'Z TicketMetric',
  'dir.reports.slaLens': 'Pohled SLA',
  'dir.reports.performanceBySegment': 'Výkon podle segmentu',
  'dir.reports.slaRatesNote': 'Míry využívají pouze záznamy s použitelným cílem SLA. Doby jsou průměrný uplynulý čas.',
  'dir.reports.slaDimensionAria': 'Dimenze rozpisu SLA',
  'dir.reports.rosterSignal': 'Přehled týmu',
  'dir.reports.agentPerformance': 'Výkon agentů',
  'dir.reports.agentPerformanceDescription': 'Zahrnuti jsou všichni aktivní agenti, včetně agentů bez aktivity.',
  'dir.reports.filterAgentsAria': 'Filtrovat agenty',
  'dir.reports.filterAgentsPlaceholder': 'Filtrovat podle agenta nebo e-mailu',
  'dir.reports.matchingAgents': 'Odpovídající agenti: {count}',
  'dir.reports.activeAgents': 'Aktivní agenti: {count}',
  'dir.reports.sortedBy': 'řazeno podle {key} {direction}',
  'dir.reports.asc': 'vzestupně',
  'dir.reports.desc': 'sestupně',
  'dir.reports.noAgentsMatch': 'Tomuto filtru neodpovídají žádní agenti',
  'dir.reports.assigned': 'Přiřazeno',
  'dir.reports.replies': 'Odpovědi',
  'dir.reports.csatScore': 'Skóre CSAT',
  'dir.reports.csatScoreDetail': 'Hodnocení 4 nebo 5',
  'dir.reports.averageRating': 'Průměrné hodnocení',
  'dir.reports.averageRatingDetail': 'Napříč ohodnocenými průzkumy',
  'dir.reports.ratedSurveys': 'Ohodnocené průzkumy',
  'dir.reports.ratedSurveysDetail': 'Ve zvoleném období',
  'dir.reports.satisfied': 'Spokojení',
  'dir.reports.satisfiedDetail': 'Pozitivní odpovědi',
  'dir.reports.responseTrend': 'Trend odpovědí',
  'dir.reports.surveyVolume': 'Objem průzkumů podle data',
  'dir.reports.surveyVolumeDescription': 'Backend vrací počet odpovědí podle data; nejde o denní skóre. Níže je vzorek posledních 100 odpovědí.',
  'dir.reports.surveyResponses': 'Odpovědi na průzkum',
  'dir.reports.surveyVolumeAria': 'Objem odpovědí na průzkum CSAT podle data',
  'dir.reports.responsesByGroup': 'Odpovědi podle skupiny',
  'dir.reports.responsesByGroupDescription': 'Počet odpovědí na průzkum, nikoli míra spokojenosti skupiny',
  'dir.reports.responsesByAgent': 'Odpovědi podle agenta',
  'dir.reports.responsesByAgentDescription': 'Počet odpovědí na průzkum, nikoli míra spokojenosti agenta',
  'dir.reports.customerVoice': 'Hlas zákazníka',
  'dir.reports.latestSurveys': 'Nejnovější odpovědi na průzkum',
  'dir.reports.boundedSample': 'Omezený vzorek · {count} z max. 100',
  'dir.reports.latestSurveysNote': 'Nejnovější odpovědi vrácené reportovacím API. Použijte tuto tabulku pro rychlý přehled, nikoli jako úplný export.',
  'dir.reports.noSurveys': 'Žádné odpovědi na průzkum',
  'dir.reports.noSurveysDescription': 'Odpovědi CSAT se zde zobrazí, jakmile zákazníci ohodnotí vyřešený tiket.',
  'dir.reports.rating': 'Hodnocení',
  'dir.reports.comment': 'Komentář',
  'dir.reports.received': 'Přijato',
  'dir.reports.ratingOutOf': '{rating} z 5',
  'dir.reports.noComment': 'Bez komentáře',
  'dir.reports.rcaEyebrow': 'Analýza hlavních příčin',
  'dir.reports.rcaTitle': 'Proč vznikají tikety',
  'dir.reports.rcaDescription': 'Kategorie a podkategorie jsou nezávislé agregace ze standardizovaných vlastních polí tiketů.',
  'dir.reports.rcaDimensionAria': 'Dimenze RCA',
  'dir.reports.category': 'Kategorie',
  'dir.reports.subcategory': 'Podkategorie',
  'dir.reports.rcaEmpty': 'Pro toto období nebyly zaznamenány žádné hodnoty hlavních příčin.',
  'dir.kb.articleLoadError': 'Článek se nepodařilo načíst.',
  'dir.kb.articleNotFound': 'Článek nebyl nalezen.',
  'dir.kb.retry': 'Zkusit znovu',
  'dir.kb.title': 'Znalostní báze',
  'dir.kb.breadcrumb': 'Znalostní báze',
  'dir.kb.description': 'Články: {articles} ve složkách: {folders}',
  'dir.kb.newArticle': 'Nový článek',
  'dir.kb.editArticle': 'Upravit článek',
  'dir.kb.sectionsAria': 'Sekce znalostní báze',
  'dir.kb.tabArticles': 'Články',
  'dir.kb.tabStructure': 'Kategorie a složky',
  'dir.kb.folderFilterAria': 'Filtr složek',
  'dir.kb.allArticles': 'Všechny články ({count})',
  'dir.kb.writeFirst': 'Napište svůj první článek',
  'dir.kb.writeFirstDescription': 'Pomocí Nový článek přidejte obsah do této složky.',
  'dir.kb.byAuthor': 'autor: {name}',
  'dir.kb.views': 'Zobrazení: {count}',
  'dir.kb.published': 'Publikováno',
  'dir.kb.draft': 'Koncept',
  'dir.kb.publish': 'Publikovat',
  'dir.kb.unpublish': 'Zrušit publikaci',
  'dir.kb.noFolders': 'V této kategorii nejsou žádné složky',
  'dir.kb.noFoldersDescription': 'Přidejte složku a začněte seskupovat články.',
  'dir.kb.articlesCount': 'Články: {count}',
  'dir.kb.fieldTitle': 'Název',
  'dir.kb.folder': 'Složka',
  'dir.kb.selectFolder': 'Vyberte složku',
  'dir.kb.content': 'Obsah',
  'dir.kb.contentPlaceholder': 'Napište obsah článku...',
  'dir.kb.tags': 'Štítky (oddělené čárkami)',
  'dir.kb.attachments': 'Přílohy',
  'dir.kb.download': 'Stáhnout',
  'dir.kb.downloadFile': 'Stáhnout {name}',
  'dir.kb.remove': 'Odebrat',
  'dir.kb.removeFile': 'Odebrat {name}',
  'dir.kb.noAttachments': 'Zatím žádné přílohy.',
  'dir.kb.uploadAria': 'Nahrát přílohu',
  'dir.kb.uploading': 'Nahrávání...',
  'dir.kb.addFile': 'Přidat soubor',
  'dir.kb.confirmDeleteTitle': 'Smazat článek?',
  'dir.kb.confirmDeleteDescription': 'Tento publikovaný článek nebo koncept bude trvale smazán.',
  'dir.kb.confirmDeleteLabel': 'Smazat článek',
  'dir.kb.confirmRemoveTitle': 'Odebrat přílohu?',
  'dir.kb.confirmRemoveDescription': 'Soubor bude z tohoto článku trvale odebrán.',
  'dir.kb.confirmRemoveLabel': 'Odebrat přílohu',
  'dir.reports.rangeInvalid': 'Zvolte platné datum začátku a konce.',
  'dir.reports.rangeOrder': 'Datum konce musí být stejné jako datum začátku nebo pozdější.',
  'dir.reports.rangeMax': 'Reporty podporují maximální rozsah 90 dní.',

  'adm.active': 'Aktivní',
  'adm.auto.action.add_tag': 'přidat štítek',
  'adm.auto.action.assign_agent': 'přiřadit agenta',
  'adm.auto.action.assign_group': 'přiřadit skupinu',
  'adm.auto.action.send_email': 'odeslat e-mail',
  'adm.auto.action.send_notification': 'odeslat oznámení',
  'adm.auto.action.set_priority': 'nastavit prioritu',
  'adm.auto.action.set_status': 'nastavit stav',
  'adm.auto.actions': 'Akce',
  'adm.auto.addAction': '+ Přidat akci',
  'adm.auto.addCondition': '+ Přidat podmínku',
  'adm.auto.addRule': 'Přidat pravidlo',
  'adm.auto.colApplied': 'Použité akce',
  'adm.auto.colDate': 'Datum',
  'adm.auto.colMatched': 'Shoda',
  'adm.auto.colSubject': 'Předmět',
  'adm.auto.colTicket': 'Tiket',
  'adm.auto.conditions': 'Podmínky',
  'adm.auto.confirmDesc': 'Toto pravidlo se okamžitě přestane spouštět a nelze ho obnovit.',
  'adm.auto.confirmLabel': 'Smazat pravidlo',
  'adm.auto.confirmTitle': 'Smazat pravidlo automatizace?',
  'adm.auto.countMany': 'Pravidla automatizace: {count}',
  'adm.auto.countOne': '{count} pravidlo automatizace',
  'adm.auto.create': 'Vytvořit',
  'adm.auto.createFirst': 'Vytvořte své první pravidlo automatizace',
  'adm.auto.createFirstDesc': 'Pomocí Přidat pravidlo můžete tikety automaticky směrovat, určovat jim prioritu nebo upozorňovat.',
  'adm.auto.deleteFailed': 'Smazání se nezdařilo',
  'adm.auto.description': 'Pravidla se spouštějí postupně podle pozice. Podmínky v rámci pravidla jsou spojeny operátorem AND.',
  'adm.auto.editRule': 'Upravit pravidlo automatizace',
  'adm.auto.execFailed': 'Spuštění se nepodařilo načíst',
  'adm.auto.field.assigneeId': 'řešitel',
  'adm.auto.field.companyId': 'společnost',
  'adm.auto.field.groupId': 'skupina',
  'adm.auto.field.priority': 'priorita',
  'adm.auto.field.requesterId': 'žadatel',
  'adm.auto.field.source': 'zdroj',
  'adm.auto.field.status': 'stav',
  'adm.auto.field.subject': 'předmět',
  'adm.auto.field.ticketTypeId': 'typ tiketu',
  'adm.auto.hits': 'Zásahy',
  'adm.auto.loadFailed': 'Pravidla automatizace se nepodařilo načíst',
  'adm.auto.log': 'Protokol',
  'adm.auto.logTitle': 'Protokol spuštění — {name}',
  'adm.auto.moveDown': 'Posunout dolů',
  'adm.auto.moveUp': 'Posunout nahoru',
  'adm.auto.newRule': 'Nové pravidlo automatizace',
  'adm.auto.no': 'Ne',
  'adm.auto.noRuns': 'Zatím nejsou zaznamenána žádná spuštění',
  'adm.auto.noRunsDesc': 'Spuštění se zde zobrazí, jakmile toto pravidlo poprvé odpovídá nějakému tiketu.',
  'adm.auto.op.contains': 'obsahuje',
  'adm.auto.op.ends_with': 'končí na',
  'adm.auto.op.greater_than': 'větší než',
  'adm.auto.op.in': 'v',
  'adm.auto.op.is': 'je',
  'adm.auto.op.is_empty': 'je prázdné',
  'adm.auto.op.is_not': 'není',
  'adm.auto.op.is_not_empty': 'není prázdné',
  'adm.auto.op.less_than': 'menší než',
  'adm.auto.op.not_contains': 'neobsahuje',
  'adm.auto.op.not_in': 'není v',
  'adm.auto.op.starts_with': 'začíná na',
  'adm.auto.reorderFailed': 'Změna pořadí se nezdařila',
  'adm.auto.saveFailed': 'Uložení se nezdařilo',
  'adm.auto.stopProcessing': 'Zastavit zpracování následujících pravidel',
  'adm.auto.title': 'Pravidla automatizace',
  'adm.auto.toggleFailed': 'Přepnutí se nezdařilo',
  'adm.auto.trigger': 'Spouštěč *',
  'adm.auto.trigger.ticket_creation': 'Vytvoření tiketu',
  'adm.auto.trigger.ticket_update': 'Aktualizace tiketu',
  'adm.auto.trigger.time_trigger': 'Časový',
  'adm.auto.triggerCol': 'Spouštěč',
  'adm.auto.valuePlaceholder': 'Hodnota',
  'adm.auto.yes': 'Ano',
  'adm.close': 'Zavřít',
  'adm.deleting': 'Mazání...',
  'adm.description': 'Popis',
  'adm.descriptionLabel': 'Popis',
  'adm.edit': 'Upravit',
  'adm.email.addChannel': 'Přidat kanál',
  'adm.email.addTitle': 'Přidat e-mailový kanál',
  'adm.email.colEmail': 'E-mail',
  'adm.email.colReplyTo': 'Adresa pro odpověď',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Tento kanál již nebude k dispozici pro poštu podpory.',
  'adm.email.confirmLabel': 'Smazat kanál',
  'adm.email.confirmTitle': 'Smazat e-mailový kanál?',
  'adm.email.countMany': 'E-mailové kanály: {count}',
  'adm.email.countOne': '{count} e-mailový kanál',
  'adm.email.create': 'Vytvořit',
  'adm.email.createFirst': 'Přidejte svůj první e-mailový kanál',
  'adm.email.createFirstDesc': 'Pomocí Přidat kanál připojte adresu podpory, aby odpovědi přicházely do tohoto centra.',
  'adm.email.default': 'Výchozí',
  'adm.email.defaultChannel': 'Výchozí kanál',
  'adm.email.deleteFailed': 'Smazání se nezdařilo',
  'adm.email.description': 'Spravujte příchozí a odchozí e-mailové adresy, konfiguraci SMTP a nastavení adresy pro odpověď.',
  'adm.email.editTitle': 'Upravit e-mailový kanál',
  'adm.email.emailAddress': 'E-mailová adresa *',
  'adm.email.loadFailed': 'Konfigurace e-mailu se nepodařilo načíst',
  'adm.email.outbound': 'Odchozí SMTP',
  'adm.email.replyTo': 'Adresa pro odpověď',
  'adm.email.replyToPh': '(výchozí je e-mailová adresa)',
  'adm.email.saveFailed': 'Uložení se nezdařilo',
  'adm.email.sesGlobal': 'SES (globální)',
  'adm.email.smtpHost': 'Server SMTP',
  'adm.email.smtpHostPh': 'např. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Heslo SMTP',
  'adm.email.smtpPort': 'Port SMTP',
  'adm.email.smtpUser': 'Uživatel SMTP',
  'adm.email.title': 'E-mailové kanály',
  'adm.groups.aboutBody': 'Členové určují, kteří agenti ve výchozím nastavení vidí tikety této skupiny. Pracovní doba řídí časování SLA u sem směrovaných tiketů a kontakt pro eskalaci je při porušení SLA tiketu upozorněn spolu s řešitelem.',
  'adm.groups.aboutTitle': 'O této skupině',
  'adm.groups.accountDefault': 'Výchozí nastavení účtu',
  'adm.groups.activeAgentMany': 'Aktivní agenti: {count}',
  'adm.groups.activeAgentOne': '{count} aktivní agent',
  'adm.groups.activeAgents': 'Aktivní agenti',
  'adm.groups.addMember': 'Přidat člena',
  'adm.groups.assignment': 'Přiřazení',
  'adm.groups.autoAssign': 'Automatické přiřazování',
  'adm.groups.autoAssignNote': 'Přiřazování tiketů je v tomto produktu vždy ruční – neexistuje round-robin ani směrování podle zatížení. Tento přepínač na tom nic nemění.',
  'adm.groups.businessHours': 'Pracovní doba',
  'adm.groups.colGroup': 'Skupina',
  'adm.groups.confirmDesc': 'Tikety a šablony používající tuto skupinu je nutné nejprve přeřadit.',
  'adm.groups.confirmLabel': 'Smazat skupinu',
  'adm.groups.confirmTitle': 'Smazat „{name}“?',
  'adm.groups.createFirst': 'Vytvořte svou první skupinu',
  'adm.groups.defaultHours': 'Výchozí pracovní doba',
  'adm.groups.editAria': 'Upravit {name}',
  'adm.groups.editGroup': 'Upravit skupinu',
  'adm.groups.escalateHelp': 'Přidá se jako příjemce oznámení, když tiket v této skupině poruší SLA.',
  'adm.groups.escalateTo': 'Eskalovat na',
  'adm.groups.escalatesTo': 'Eskaluje na',
  'adm.groups.escalatesToName': 'Eskaluje na {name}',
  'adm.groups.escalationBody': 'Když tiket v této skupině poruší SLA, kontakt pro eskalaci se přidá jako příjemce oznámení spolu s řešitelem a členy skupiny.',
  'adm.groups.escalationTitle': 'Kontakt pro eskalaci',
  'adm.groups.hoursHelp': 'Používá se pro výpočty SLA u tiketů v této skupině.',
  'adm.groups.manageAgents': 'Spravovat agenty',
  'adm.groups.manageHours': 'Spravovat pracovní dobu',
  'adm.groups.manual': 'Ruční',
  'adm.groups.manualBody': 'Přiřazování je v tomto produktu ruční – neexistuje round-robin ani automatické přiřazování podle zatížení. Přepínač „Automatické přiřazování“ u skupiny ovlivňuje pouze to, zda nové tikety v dané skupině zůstanou ve výchozím stavu nepřiřazené, nebo se použije stávající pravidlo směrování; agenti si tikety stále přebírají a předávají sami.',
  'adm.groups.manualTitle': 'Ruční přiřazování',
  'adm.groups.memberMany': 'Členové: {count}',
  'adm.groups.memberOne': '{count} člen',
  'adm.groups.members': 'Členové',
  'adm.groups.newGroup': 'Nová skupina',
  'adm.groups.noEscalation': 'Žádný kontakt pro eskalaci',
  'adm.groups.noMatch': 'Tomuto hledání neodpovídají žádné skupiny',
  'adm.groups.noMembers': 'Zatím žádní členové',
  'adm.groups.noMembersDesc': 'Výše vyberte aktivního agenta a zvolte Přidat člena.',
  'adm.groups.remove': 'Odebrat',
  'adm.groups.routing': 'Směrování',
  'adm.groups.routingMethod': 'Způsob směrování',
  'adm.groups.saved': 'Skupina byla uložena.',
  'adm.groups.searchAria': 'Hledat skupiny',
  'adm.groups.searchPlaceholder': 'Hledat podle jména',
  'adm.groups.selectActiveAgent': 'Vyberte aktivního agenta',
  'adm.groups.showing': 'Zobrazeno {start}–{end} z {total}',
  'adm.groups.subtitle': 'Skupiny řídí směrování a viditelnost tiketů. Přiřaďte agenty jako členy a pro každou skupinu zvolte rozvrh pracovní doby a kontakt pro eskalaci.',
  'adm.groups.title': 'Skupiny',
  'adm.groups.tryDifferent': 'Zkuste jiný název skupiny.',
  'adm.groups.unassigned': 'Nepřiřazeno',
  'adm.groups.useNew': 'Pomocí Nová skupina směrujte tikety na skupinu agentů.',
  'adm.groups.zero': '0 skupin',
  'adm.inactive': 'Neaktivní',
  'adm.jira.accepted': 'Připojení přijato',
  'adm.jira.accountEmail': 'E-mail účtu Jira',
  'adm.jira.accountEmailLabel': 'E-mail účtu',
  'adm.jira.activeConn': 'Aktivní připojení',
  'adm.jira.addConnection': 'Přidat připojení',
  'adm.jira.addTitle': 'Přidat připojení Jira',
  'adm.jira.added': 'Připojení Jira bylo přidáno',
  'adm.jira.apiToken': 'Token API',
  'adm.jira.clearSecret': 'Vymazat uložené tajemství webhooku',
  'adm.jira.confirmDesc': 'Tím se odebere uložené připojení a jeho propojení s tikety. Issue v Jira se nemažou.',
  'adm.jira.confirmLabel': 'Smazat připojení',
  'adm.jira.confirmTitle': 'Smazat {name}?',
  'adm.jira.connName': 'Název připojení',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Připojeno jako {name}',
  'adm.jira.connectionDesk': 'Správa připojení',
  'adm.jira.default': 'Výchozí',
  'adm.jira.defaultConn': 'Výchozí připojení',
  'adm.jira.defaultIssueType': 'Výchozí typ issue',
  'adm.jira.defaultProjectKey': 'Výchozí klíč projektu',
  'adm.jira.defaults': 'Výchozí hodnoty',
  'adm.jira.description': 'Připojte weby Jira vlastněné účtem, aby agenti mohli propojovat issue a udržovat stav tiketů v souladu.',
  'adm.jira.editTitle': 'Upravit připojení Jira',
  'adm.jira.footer': 'Vytvořte webhook v Jira s koncovým bodem zobrazeným výše, přihlaste odběr událostí aktualizace issue a použijte stejné tajemství webhooku, jaké je nastaveno zde.',
  'adm.jira.heading': 'Udržujte podporu a vývoj ve stejné smyčce',
  'adm.jira.intro': 'Přihlašovací údaje se ukládají na serveru zašifrované a na tuto obrazovku se nikdy nevrací. Nastavte tajemství webhooku, pokud má Jira posílat změny stavu zpět do SuzukiDesk.',
  'adm.jira.no': 'Ne',
  'adm.jira.noConns': 'Zatím žádná připojení Jira',
  'adm.jira.noConnsDesc': 'Přidejte připojení, aby byly akce Jira dostupné z detailu tiketu.',
  'adm.jira.noProject': 'Žádný projekt',
  'adm.jira.pasteToken': 'Vložte token',
  'adm.jira.requestFailed': 'Požadavek na Jira se nezdařil. Zkuste to prosím znovu.',
  'adm.jira.savedToast': 'Připojení Jira bylo uloženo',
  'adm.jira.secretConfigured': 'Tajemství nastaveno: {value}',
  'adm.jira.secretHint': 'Při vytváření webhooku v Jira použijte stejné tajemství.',
  'adm.jira.secretOptional': 'Volitelné, 16+ znaků',
  'adm.jira.siteUrl': 'URL webu Jira',
  'adm.jira.siteUrlHint': 'Do URL nezahrnujte přihlašovací údaje.',
  'adm.jira.syncFromJira': 'Stav z Jira zpět do tiketu',
  'adm.jira.syncSnapshot': 'Snímek propojeného issue',
  'adm.jira.syncToJira': 'Stav tiketu do Jira',
  'adm.jira.testConnection': 'Otestovat připojení',
  'adm.jira.testFailed': 'Test připojení se nezdařil',
  'adm.jira.title': 'Integrace Jira',
  'adm.jira.tokenHintEdit': 'Ponechte prázdné, chcete-li zachovat stávající token.',
  'adm.jira.tokenHintNew': 'Uloženo zašifrovaně; znovu se nezobrazí.',
  'adm.jira.tokenMissing': 'Token API chybí',
  'adm.jira.tokenStored': 'Token API uložen',
  'adm.jira.unchanged': '(beze změny, pokud je prázdné)',
  'adm.jira.verified': 'Připojení Jira bylo ověřeno',
  'adm.jira.webhookEndpoint': 'Koncový bod webhooku Jira',
  'adm.jira.webhookSecret': 'Tajemství webhooku',
  'adm.jira.whatSyncs': 'Co se synchronizuje',
  'adm.jira.yes': 'Ano',
  'adm.nameRequired': 'Název *',
  'adm.nextPage': 'Další stránka',
  'adm.notif.aud.all': 'Sdílené',
  'adm.notif.aud.customer': 'Zákazník',
  'adm.notif.aud.internal': 'Interní',
  'adm.notif.audEmail': 'E-mail: {audience}',
  'adm.notif.body': 'Text',
  'adm.notif.description': 'Přizpůsobte každé publikum oznámení, aniž byste zákazníky posílali do interního pracovního prostoru.',
  'adm.notif.discardDesc': 'Neuložené změny této šablony oznámení budou při přepnutí šablony ztraceny.',
  'adm.notif.discardLabel': 'Zahodit změny',
  'adm.notif.discardTitle': 'Zahodit neuložené změny?',
  'adm.notif.discarded': 'Neuložené změny byly zahozeny.',
  'adm.notif.event.automation_notification': 'Oznámení automatizace',
  'adm.notif.event.group_member_added': 'Přidání do skupiny',
  'adm.notif.event.mention': 'Zmínka',
  'adm.notif.event.pending_input': 'Čeká se na vstup',
  'adm.notif.event.sla_breach': 'Porušení SLA',
  'adm.notif.event.sla_escalation': 'Eskalace SLA',
  'adm.notif.event.sla_warning': 'Upozornění SLA',
  'adm.notif.event.ticket_assigned': 'Tiket přiřazen',
  'adm.notif.event.ticket_created': 'Tiket vytvořen',
  'adm.notif.event.ticket_first_response': 'První odpověď',
  'adm.notif.event.ticket_group_assigned': 'Tiket přiřazen skupině',
  'adm.notif.event.ticket_note': 'Soukromá poznámka',
  'adm.notif.event.ticket_public_note': 'Veřejná poznámka',
  'adm.notif.event.ticket_reply': 'Odpověď na tiket',
  'adm.notif.event.ticket_resolved': 'Tiket vyřešen',
  'adm.notif.events': 'Události',
  'adm.notif.eventsHelp': 'Vyberte událost a publikum příjemců.',
  'adm.notif.insertVar': 'Vložit {variable}',
  'adm.notif.linkNoteAgent': 'Proměnná odkazu {variable} přizpůsobená publiku otevře pro tento e-mail pracovní prostor agenta.',
  'adm.notif.linkNoteCustomer': 'Proměnná odkazu {variable} přizpůsobená publiku otevře pro tento e-mail zákaznický portál.',
  'adm.notif.off': 'vypnuto',
  'adm.notif.preview': 'Náhled',
  'adm.notif.previewNotice': 'Náhled byl vykreslen s ukázkovými daty.',
  'adm.notif.rendering': 'Vykreslování…',
  'adm.notif.route.all': 'Používá odkaz na tiket podle příjemce pro dané publikum doručení.',
  'adm.notif.route.customer': 'Hlavní akce otevře tiket v zákaznickém portálu.',
  'adm.notif.route.internal': 'Hlavní akce otevře tiket v pracovním prostoru agenta.',
  'adm.notif.sampleOnlyAgent': 'Pouze ukázková data — hlavní akce míří do pracovního prostoru agenta.',
  'adm.notif.sampleOnlyCustomer': 'Pouze ukázková data — hlavní akce míří do zákaznického portálu.',
  'adm.notif.saveChanges': 'Uložit změny',
  'adm.notif.saved': 'Šablona byla uložena.',
  'adm.notif.savedBtn': 'Uloženo',
  'adm.notif.selectEvent': 'Vyberte událost a upravte její šablonu',
  'adm.notif.selectEventDesc': 'Vlevo vyberte událost oznámení a změňte její předmět a text.',
  'adm.notif.sendTest': 'Odeslat testovací e-mail',
  'adm.notif.sending': 'Odesílání…',
  'adm.notif.subject': 'Předmět',
  'adm.notif.testQueued': 'Testovací e-mail byl zařazen k odeslání na {email}.',
  'adm.notif.title': 'Šablony oznámení',
  'adm.notif.urlVarTitle': 'Proměnná odkazu podle publika',
  'adm.notif.useTemplate': 'Použít tuto šablonu pro toto publikum',
  'adm.notif.useTemplateHelp': 'Po vypnutí se použije bezpečné záložní oznámení.',
  'adm.notif.variables': 'Proměnné',
  'adm.notif.variablesHelp': 'Kliknutím přidáte do textu zprávy',
  'adm.pagination': 'Stránkování',
  'adm.perm.cap.admin.label': 'Přístup do konzole administrace',
  'adm.perm.cap.assign.label': 'Přiřadit tiket',
  'adm.perm.cap.close.label': 'Uzavřít tiket',
  'adm.perm.cap.conversation_delete.label': 'Smazat odeslanou odpověď nebo poznámku',
  'adm.perm.cap.conversation_edit.label': 'Upravit odeslanou odpověď nebo poznámku',
  'adm.perm.cap.create.label': 'Vytvořit tiket',
  'adm.perm.cap.delete.label': 'Smazat tiket',
  'adm.perm.cap.edit.label': 'Upravit vlastnosti tiketu',
  'adm.perm.cap.export.label': 'Exportovat tikety',
  'adm.perm.cap.field_admin.label': 'Pole tiketu',
  'adm.perm.cap.form_admin.label': 'Formuláře tiketů',
  'adm.perm.cap.forward.label': 'Přeposlat tiket',
  'adm.perm.cap.jira_link.label': 'Propojovat a spravovat issue v Jira',
  'adm.perm.cap.kb.label': 'Přístup ke znalostní bázi',
  'adm.perm.cap.manage_agents.label': 'Agenti',
  'adm.perm.cap.manage_api_keys.label': 'Klíče API',
  'adm.perm.cap.manage_automations.label': 'Automatizace',
  'adm.perm.cap.manage_canned_responses.label': 'Předpřipravené odpovědi',
  'adm.perm.cap.manage_email_config.label': 'E-mail',
  'adm.perm.cap.manage_groups.label': 'Skupiny',
  'adm.perm.cap.manage_jira.label': 'Integrace Jira',
  'adm.perm.cap.manage_kb.label': 'Znalostní báze',
  'adm.perm.cap.manage_notification_templates.label': 'Šablony oznámení',
  'adm.perm.cap.manage_roles.label': 'Role',
  'adm.perm.cap.manage_tags.label': 'Štítky',
  'adm.perm.cap.note.label': 'Přidávat nebo upravovat soukromé poznámky',
  'adm.perm.cap.reassign.label': 'Přeřadit tiket, který již vlastní někdo jiný',
  'adm.perm.cap.reopen.label': 'Znovu otevřít vyřešený nebo uzavřený tiket',
  'adm.perm.cap.reply.label': 'Veřejně odpovídat zákazníkovi',
  'adm.perm.cap.report_access.label': 'Zobrazit reporty a přehledy',
  'adm.perm.cap.reports.label': 'Přístup k modulu reportů',
  'adm.perm.cap.resolve.label': 'Vyřešit tiket',
  'adm.perm.cap.settings_admin.label': 'Otevřít sekci Nastavení (nutné k zobrazení položky Nastavení v navigaci a její úvodní stránky; přístup k jednotlivým stránkám níže se stále řídí samostatně)',
  'adm.perm.cap.sla_admin.label': 'Pravidla SLA a pracovní doba',
  'adm.perm.cap.sla_edit.desc': 'Odděleno od oprávnění Nastavení > Pravidla SLA níže — toto se týká pouze úprav termínů u jednotlivého tiketu.',
  'adm.perm.cap.sla_edit.label': 'Ručně přepsat termíny SLA tiketu',
  'adm.perm.cap.tag.label': 'Spravovat štítky tiketů',
  'adm.perm.cap.thread_start.label': 'Zahájit soukromé vlákno u položky konverzace',
  'adm.perm.cap.tickets.label': 'Přístup k pracovnímu prostoru tiketů',
  'adm.perm.cap.view.label': 'Zobrazit tikety v rozsahu',
  'adm.perm.cat.administration.desc': 'Přístup ke konzoli administrace a jejím konfiguračním obrazovkám.',
  'adm.perm.cat.administration.label': 'Administrace',
  'adm.perm.cat.knowledge.desc': 'Čtení a používání obsahu znalostní báze při práci na tiketu.',
  'adm.perm.cat.knowledge.label': 'Znalostní báze',
  'adm.perm.cat.reporting.desc': 'Provozní reporty a přehledy.',
  'adm.perm.cat.reporting.label': 'Reporty',
  'adm.perm.cat.settings-pages.desc': 'Udělte přístup ke každé obrazovce Nastavení zvlášť. Dokud zde není výslovně zaškrtnuto, nic se nezobrazí.',
  'adm.perm.cat.settings-pages.label': 'Stránky nastavení',
  'adm.perm.cat.tickets.desc': 'Co může agent dělat v pracovním prostoru tiketů.',
  'adm.perm.cat.tickets.label': 'Tikety',
  'adm.previousPage': 'Předchozí stránka',
  'adm.refresh': 'Obnovit',
  'adm.roleType.administrator': 'Administrátor',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Spolupracovník',
  'adm.roleType.customer': 'Zákazník',
  'adm.roleType.super_admin': 'Superadministrátor',
  'adm.roleType.supervisor': 'Supervizor',
  'adm.roles.activeHelp': 'Aktivní – neaktivní role nelze přiřadit agentům',
  'adm.roles.agentCan': 'Agent může',
  'adm.roles.agentType': 'Typ agenta',
  'adm.roles.agentsAssignedNote': 'Agentům se tato role přiřazuje na obrazovce Agenti.',
  'adm.roles.agentsCount': 'Agenti: {count}',
  'adm.roles.agentsLabel': 'Agenti',
  'adm.roles.agentsManage': 'Agenti: {count} – Spravovat',
  'adm.roles.builtIn': '(Vestavěná)',
  'adm.roles.builtInNote': 'Toto je vestavěná role. Lze ji přejmenovat a deaktivovat, ale ne smazat.',
  'adm.roles.builtInTitle': 'Vestavěná role: lze upravit a deaktivovat, ale nelze smazat',
  'adm.roles.categoriesAria': 'Kategorie oprávnění',
  'adm.roles.confirmDesc': 'Agenti s touto rolí budou před jejím odebráním potřebovat jinou roli.',
  'adm.roles.confirmLabel': 'Smazat roli',
  'adm.roles.createFirst': 'Vytvořte svou první roli',
  'adm.roles.createFirstDesc': 'Pomocí Nová role definujte schopnosti, které mají agenti získat.',
  'adm.roles.editRole': 'Upravit roli',
  'adm.roles.granted': 'Uděleno: {count}',
  'adm.roles.heading': 'Role agentů',
  'adm.roles.inactive': 'Neaktivní',
  'adm.roles.newRole': 'Nová role',
  'adm.roles.noAgent': 'Žádný agent',
  'adm.roles.notEnforced': '(zatím se nevynucuje)',
  'adm.roles.notEnforcedTitle': 'Uloženo u role, ale za běhu se zatím nikde nekontroluje',
  'adm.roles.permissions': 'Oprávnění',
  'adm.roles.saved': 'Role byla uložena.',
  'adm.roles.scopeBody': 'Schopnosti se kombinují s rozsahem na úrovni řádků (vše / skupina / přiřazené / vlastní), takže agent vždy jedná jen s tikety, které již vidí.',
  'adm.roles.scopeTitle': 'Rozsah se stále uplatňuje',
  'adm.roles.scrollTo': 'Přejít na',
  'adm.roles.status': 'Stav',
  'adm.roles.subtitle': 'Poskytujte a omezujte podrobné úrovně přístupu a oprávnění pro agenty.',
  'adm.roles.title': 'Role',
  'adm.roles.typeLocked': 'Typ agenta nelze po uložení role změnit.',
  'adm.roles.understandingBody1': 'Role určují, co může agent dělat. Vytvořte roli, zaškrtněte schopnosti, které má udělovat, a poté ji přiřaďte agentům na obrazovce Agenti.',
  'adm.roles.understandingBody2': 'Vestavěné role lze přejmenovat a deaktivovat, ale nikdy smazat. Roli, která má stále přiřazené agenty, také nelze smazat, takže tyto agenty nejprve přesuňte.',
  'adm.roles.understandingTitle': 'Principy rolí',
  'adm.saveChanges': 'Uložit změny',
  'adm.settings.add': 'Přidat: {name}',
  'adm.settings.back': 'Zpět na nastavení',
  'adm.settings.cannedDesc': 'Odpovědi účtu dostupné při práci na tiketu.',
  'adm.settings.cannedEmpty': 'Zatím žádné předpřipravené odpovědi',
  'adm.settings.cannedEmptyDesc': 'Požádejte administrátora o přidání sdílených odpovědí, které může váš tým použít v tiketu.',
  'adm.settings.cannedTitle': 'Předpřipravené odpovědi',
  'adm.settings.col.autoAssign': 'Automatické přiřazení',
  'adm.settings.col.color': 'Barva',
  'adm.settings.col.content': 'Obsah',
  'adm.settings.col.createdAt': 'Vytvořeno',
  'adm.settings.col.description': 'Popis',
  'adm.settings.col.email': 'E-mail',
  'adm.settings.col.expiresAt': 'Platí do',
  'adm.settings.col.fieldType': 'Typ pole',
  'adm.settings.col.firstName': 'Jméno',
  'adm.settings.col.folderId': 'ID složky',
  'adm.settings.col.hitCount': 'Počet zásahů',
  'adm.settings.col.holidays': 'Svátky',
  'adm.settings.col.host': 'Server',
  'adm.settings.col.hours': 'Hodiny',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Aktivní',
  'adm.settings.col.isBuiltIn': 'Vestavěné',
  'adm.settings.col.isDefault': 'Výchozí',
  'adm.settings.col.isRequired': 'Povinné',
  'adm.settings.col.isShared': 'Sdílené',
  'adm.settings.col.isSystem': 'Systémové',
  'adm.settings.col.key': 'Klíč',
  'adm.settings.col.label': 'Popisek',
  'adm.settings.col.language': 'Jazyk',
  'adm.settings.col.lastName': 'Příjmení',
  'adm.settings.col.lastUsedAt': 'Naposledy použito',
  'adm.settings.col.name': 'Název',
  'adm.settings.col.options': 'Možnosti',
  'adm.settings.col.phone': 'Telefon',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Pozice',
  'adm.settings.col.prefix': 'Předpona',
  'adm.settings.col.priority': 'Priorita',
  'adm.settings.col.required': 'Povinné',
  'adm.settings.col.role': 'Role',
  'adm.settings.col.roleId': 'ID role',
  'adm.settings.col.scopes': 'Rozsahy',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Stav',
  'adm.settings.col.stopProcessing': 'Zastavit zpracování',
  'adm.settings.col.timezone': 'Časové pásmo',
  'adm.settings.col.title': 'Název',
  'adm.settings.col.trigger': 'Spouštěč',
  'adm.settings.col.type': 'Typ',
  'adm.settings.col.updatedAt': 'Aktualizováno',
  'adm.settings.col.usageCount': 'Počet použití',
  'adm.settings.col.username': 'Uživatelské jméno',
  'adm.settings.confirmDesc': 'Tuto akci nelze vrátit zpět.',
  'adm.settings.confirmTitle': 'Smazat {name}?',
  'adm.settings.count': '{title}: {count}',
  'adm.settings.create': 'Vytvořit',
  'adm.settings.empty': 'Zatím žádné položky: {title}',
  'adm.settings.emptyAdd': 'Pomocí formuláře výše přidejte svou první položku: {name}.',
  'adm.settings.emptyOther': 'Položky se zde zobrazí po jejich nakonfigurování.',
  'adm.settings.homeDesc': 'Konfigurace uživatelů, pracovních postupů tiketů, úrovní služeb a integrací.',
  'adm.settings.manage': 'Správa: {title}.',
  'adm.settings.noPages': 'Nejsou k dispozici žádné stránky nastavení',
  'adm.settings.noPagesDesc': 'Požádejte superadministrátora o přidělení přístupu ke stránkám nastavení, které potřebujete.',
  'adm.settings.notFound': 'Stránka nastavení nebyla nalezena',
  'adm.settings.notFoundDesc': 'Pro pokračování vyberte oblast nastavení.',
  'adm.settings.res.agents.field.email': 'E-mail',
  'adm.settings.res.agents.field.firstName': 'Jméno',
  'adm.settings.res.agents.field.lastName': 'Příjmení',
  'adm.settings.res.agents.field.password': 'Dočasné heslo',
  'adm.settings.res.agents.field.roleId': 'ID role',
  'adm.settings.res.agents.one': 'agenta',
  'adm.settings.res.agents.title': 'Agenti',
  'adm.settings.res.api-keys.field.name': 'Název klíče',
  'adm.settings.res.api-keys.one': 'klíč API',
  'adm.settings.res.api-keys.title': 'Klíče API',
  'adm.settings.res.automations.field.description': 'Popis',
  'adm.settings.res.automations.field.name': 'Název',
  'adm.settings.res.automations.one': 'automatizaci',
  'adm.settings.res.automations.title': 'Automatizace',
  'adm.settings.res.business-hours.field.name': 'Název',
  'adm.settings.res.business-hours.field.timezone': 'Časové pásmo',
  'adm.settings.res.business-hours.one': 'záznam pracovní doby',
  'adm.settings.res.business-hours.title': 'Pracovní doba',
  'adm.settings.res.canned-responses.field.content': 'Obsah odpovědi',
  'adm.settings.res.canned-responses.field.title': 'Název',
  'adm.settings.res.canned-responses.one': 'předpřipravenou odpověď',
  'adm.settings.res.canned-responses.title': 'Předpřipravené odpovědi',
  'adm.settings.res.email.field.host': 'Server SMTP',
  'adm.settings.res.email.field.name': 'Název',
  'adm.settings.res.email.field.port': 'Port SMTP',
  'adm.settings.res.email.field.username': 'Uživatelské jméno',
  'adm.settings.res.email.one': 'konfiguraci e-mailu',
  'adm.settings.res.email.title': 'Konfigurace e-mailu',
  'adm.settings.res.fields.one': 'pole tiketu',
  'adm.settings.res.fields.title': 'Pole tiketu',
  'adm.settings.res.forms.field.label': 'Zobrazovaný popisek',
  'adm.settings.res.forms.field.name': 'Název pole',
  'adm.settings.res.forms.field.type': 'Typ pole',
  'adm.settings.res.forms.one': 'formulář nebo vlastní pole',
  'adm.settings.res.forms.title': 'Formuláře a vlastní pole',
  'adm.settings.res.groups.field.description': 'Popis',
  'adm.settings.res.groups.field.name': 'Název',
  'adm.settings.res.groups.one': 'skupinu',
  'adm.settings.res.groups.title': 'Skupiny',
  'adm.settings.res.jira.one': 'integraci Jira',
  'adm.settings.res.jira.title': 'Integrace Jira',
  'adm.settings.res.kb.field.content': 'Obsah článku',
  'adm.settings.res.kb.field.folderId': 'ID složky',
  'adm.settings.res.kb.field.title': 'Název článku',
  'adm.settings.res.kb.one': 'článek znalostní báze',
  'adm.settings.res.kb.title': 'Administrace znalostní báze',
  'adm.settings.res.notification-templates.one': 'šablonu oznámení',
  'adm.settings.res.notification-templates.title': 'Šablony oznámení',
  'adm.settings.res.roles.field.description': 'Popis',
  'adm.settings.res.roles.field.name': 'Název',
  'adm.settings.res.roles.field.type': 'Typ role',
  'adm.settings.res.roles.one': 'roli',
  'adm.settings.res.roles.title': 'Role',
  'adm.settings.res.sla.field.description': 'Popis',
  'adm.settings.res.sla.field.name': 'Název',
  'adm.settings.res.sla.one': 'pravidlo SLA',
  'adm.settings.res.sla.title': 'Pravidla SLA',
  'adm.settings.res.tags.field.name': 'Název',
  'adm.settings.res.tags.one': 'štítek',
  'adm.settings.res.tags.title': 'Štítky',
  'adm.settings.title': 'Nastavení',
  'adm.status': 'Stav',

  'sla.edit': 'Upravit',
  'sla.active': 'Aktivní',
  'sla.inactive': 'Neaktivní',
  'sla.default': 'Výchozí',
  'sla.yes': 'Ano',
  'sla.no': 'Ne',
  'sla.description': 'Popis',
  'sla.status': 'Stav',
  'sla.notConfigured': 'Nenakonfigurováno',
  'sla.minutesValue': '{value} min',
  'sla.invalidServerValue': 'Neplatná hodnota ze serveru',
  'sla.statusSemantics.title': 'Sémantika stavů tiketu',
  'sla.statusSemantics.description': 'Každý aktivní stav má výslovnou smlouvu SLA. Stav, který pozastavuje SLA, a stav, který SLA zastavuje, se vzájemně vylučují.',
  'sla.statusSemantics.conflict': 'Stav nemůže zároveň pozastavovat SLA a zastavovat SLA.',
  'sla.statusSemantics.emptyTitle': 'Žádné definice stavů',
  'sla.statusSemantics.emptyDescription': 'Definice stavů se zde zobrazí po jejich nakonfigurování pro tento účet.',
  'sla.statusSemantics.colPauses': 'Pozastavuje SLA',
  'sla.statusSemantics.colStops': 'Zastavuje SLA',
  'sla.statusSemantics.pausesAria': '{label} pozastavuje SLA',
  'sla.statusSemantics.stopsAria': '{label} zastavuje SLA',
  'sla.preview.title': 'Náhled tiketu jen pro čtení',
  'sla.preview.description': 'Spusťte stejný vyhodnocovač v rámci účtu, který používají živé cykly SLA. Tento náhled nikdy nezapisuje pravidlo ani tiket.',
  'sla.preview.priority': 'Priorita',
  'sla.preview.group': 'Skupina',
  'sla.preview.anyGroup': 'Kterákoli skupina',
  'sla.preview.company': 'Společnost',
  'sla.preview.anyCompany': 'Kterákoli společnost',
  'sla.preview.source': 'Zdroj',
  'sla.preview.anySource': 'Kterýkoli zdroj',
  'sla.preview.ticketType': 'Typ tiketu',
  'sla.preview.anyTicketType': 'Kterýkoli typ tiketu',
  'sla.preview.representativeStart': 'Reprezentativní začátek',
  'sla.preview.calculating': 'Výpočet…',
  'sla.preview.run': 'Spustit náhled',
  'sla.preview.configAttention': 'Konfigurace vyžaduje pozornost',
  'sla.preview.selectedPolicy': 'Vybrané pravidlo',
  'sla.preview.noPolicy': 'Žádné pravidlo',
  'sla.preview.evaluationOrder': 'Pořadí vyhodnocení',
  'sla.preview.firstMatching': 'První odpovídající pravidlo',
  'sla.preview.calculationMode': 'Režim výpočtu',
  'sla.preview.modeBusinessHours': 'Pracovní doba',
  'sla.preview.modeBusinessHoursNamed': 'Pracovní doba · {name}',
  'sla.preview.mode247': 'Uplynulý čas 24/7',
  'sla.preview.modeNone': 'Nevypočteno',
  'sla.preview.thresholds': 'Nezávislé prahové hodnoty',
  'sla.preview.colMetric': 'Metrika',
  'sla.preview.colTarget': 'Cíl',
  'sla.preview.colWarning': 'Upozornění',
  'sla.preview.colDue': 'Termín / porušení',
  'sla.preview.colEscalation': 'Eskalace',
  'sla.preview.colState': 'Stav',
  'sla.preview.metricFirstResponse': 'První odpověď',
  'sla.preview.metricResolution': 'Vyřešení',
  'sla.preview.trace': 'Stopa vyhodnocení pravidel',
  'sla.preview.selected': 'Vybráno',
  'sla.preview.matchedAfterSelection': 'Shoda po výběru',
  'sla.preview.skipped': 'Přeskočeno',
  'sla.preview.showTrace': 'Zobrazit stopu výpočtu',
  'sla.state.not_configured': 'nenakonfigurováno',
  'sla.state.running': 'běží',
  'sla.state.paused': 'pozastaveno',
  'sla.state.warning': 'upozornění',
  'sla.state.breached': 'porušeno',
  'sla.state.met': 'splněno',
  'sla.state.escalated': 'eskalováno',
  'sla.state.pending': 'čeká',
  'sla.state.stopped': 'zastaveno',
  'sla.state.on_track': 'v plánu',
  'sla.state.at_risk': 'ohroženo',
  'sla.list.subtitle': 'Nastavte cíle první odpovědi a vyřešení pro každou prioritu. Pravidla se vyhodnocují shora dolů — vyhrává první, jehož podmínky tiketu odpovídají.',
  'sla.list.newPolicy': 'Nové pravidlo',
  'sla.list.emptyTitle': 'Vytvořte své první pravidlo SLA',
  'sla.list.emptyDescription': 'Pomocí Nové pravidlo nastavte cíle první odpovědi a vyřešení pro každou prioritu.',
  'sla.list.moveUp': 'Posunout nahoru',
  'sla.list.moveDown': 'Posunout dolů',
  'sla.list.frShort': 'PO: {value}',
  'sla.list.resolveShort': 'Vyřešení: {value}',
  'sla.list.escalateShort': 'Eskalace: +{value}',
  'sla.list.deactivate': 'Deaktivovat',
  'sla.list.activate': 'Aktivovat',
  'sla.list.setDefault': 'Nastavit jako výchozí',
  'sla.list.duplicate': 'Duplikovat',
  'sla.list.deleteTitle': 'Smazat „{name}“?',
  'sla.list.deleteDescription': 'Tikety přiřazené k tomuto pravidlu budou používat další dostupné pravidlo SLA.',
  'sla.list.deleteConfirm': 'Smazat pravidlo',
  'sla.conditions.groups': 'Skupiny: {count}',
  'sla.conditions.companies': 'Společnosti: {count}',
  'sla.conditions.sources': 'zdroje: {list}',
  'sla.conditions.ticketTypes': 'Typy tiketů: {count}',
  'sla.conditions.anyOf': 'kterákoli z',
  'sla.conditions.allOf': 'všechny z',
  'sla.conditions.summary': 'Podmínky ({mode}): {parts}',
  'sla.edit.newTitle': 'Nové pravidlo SLA',
  'sla.edit.editTitle': 'Upravit pravidlo SLA',
  'sla.edit.saved': 'Pravidlo SLA bylo uloženo.',
  'sla.edit.name': 'Název',
  'sla.edit.appliesToPriority': 'Platí pro prioritu',
  'sla.edit.evaluationOrder': 'Pořadí vyhodnocení',
  'sla.edit.evaluationOrderHint': 'Nižší pozice se pro tento účet vyhodnocují jako první.',
  'sla.edit.defaultPolicy': 'Výchozí pravidlo',
  'sla.edit.useAsDefault': 'Použít jako výchozí, pokud neodpovídá žádné jiné pravidlo',
  'sla.edit.targets': 'Cíle SLA',
  'sla.edit.firstResponse': 'První odpověď',
  'sla.edit.resolution': 'Vyřešení',
  'sla.edit.autoAt75': 'Automaticky při 75 %',
  'sla.edit.enabledAfter': 'Zapnuto po {value}',
  'sla.edit.clearEscalation': 'Výslovně zrušit cíl eskalace',
  'sla.edit.clearEscalationHint': 'Odešle null; ponecháte-li nezaškrtnuto, pole se vynechá a uložená hodnota zůstane zachována.',
  'sla.edit.firstResponseMinutes': 'První odpověď (minuty)',
  'sla.edit.resolutionMinutes': 'Vyřešení (minuty)',
  'sla.edit.escalateAfter': 'Eskalovat po (minuty po termínu vyřešení)',
  'sla.edit.notSet': 'Nenastaveno',
  'sla.edit.remindersNote': 'Připomenutí se spouštějí automaticky při 75 % oken první odpovědi a vyřešení. Eskalace upozorní agenta pro eskalaci skupiny tiketu (nastaveného u skupiny), jakmile je cíl vyřešení překročen o nastavený počet minut.',
  'sla.edit.conditions': 'Podmínky',
  'sla.edit.conditionsHint': 'Ponechte skupinu nezaškrtnutou, aby odpovídaly všechny hodnoty',
  'sla.edit.matchMode': 'Režim shody:',
  'sla.edit.matchAll': 'Musí platit VŠECHNY podmínky',
  'sla.edit.matchAny': 'Musí platit ALESPOŇ JEDNA podmínka',
  'sla.edit.groups': 'Skupiny',
  'sla.edit.companies': 'Společnosti',
  'sla.edit.sources': 'Zdroje',
  'sla.edit.ticketTypes': 'Typy tiketů',
  'sla.bh.subtitle': 'Definujte týdenní rozvrh a kalendář svátků, které pravidla SLA používají k výpočtu termínů.',
  'sla.bh.newCalendar': 'Nový kalendář',
  'sla.bh.emptyTitle': 'Vytvořte svůj první kalendář pracovní doby',
  'sla.bh.emptyDescription': 'Pomocí Nový kalendář definujte týdenní rozvrh, podle kterého pravidla SLA počítají.',
  'sla.bh.accountDefault': 'Výchozí nastavení účtu',
  'sla.bh.closedEveryDay': 'Zavřeno každý den',
  'sla.bh.openEveryDay': 'Otevřeno každý den',
  'sla.bh.openDaysOne': 'Otevřeno 1 den v týdnu',
  'sla.bh.openDaysMany': 'Otevřeno dní v týdnu: {count}',
  'sla.bh.holidayOne': '1 svátek',
  'sla.bh.holidayMany': 'Svátky: {count}',
  'sla.bh.deleteTitle': 'Smazat „{name}“?',
  'sla.bh.deleteDescription': 'Pravidla SLA a skupiny používající tento rozvrh přejdou na výchozí nastavení účtu.',
  'sla.bh.deleteConfirm': 'Smazat rozvrh',
  'sla.bh.newTitle': 'Nový kalendář pracovní doby',
  'sla.bh.editTitle': 'Upravit pracovní dobu',
  'sla.bh.saved': 'Pracovní doba byla uložena.',
  'sla.bh.timezone': 'Časové pásmo',
  'sla.bh.defaultCalendar': 'Výchozí kalendář',
  'sla.bh.useAsDefault': 'Použít pro pravidla SLA a skupiny, které nemají vlastní kalendář',
  'sla.bh.weeklySchedule': 'Týdenní rozvrh',
  'sla.bh.colDay': 'Den',
  'sla.bh.colOpen': 'Otevřeno',
  'sla.bh.colStart': 'Začátek',
  'sla.bh.colEnd': 'Konec',
  'sla.bh.dayOpenAria': '{day} otevřeno',
  'sla.bh.dayStartAria': '{day} čas začátku',
  'sla.bh.dayEndAria': '{day} čas konce',
  'sla.bh.holidayCalendar': 'Kalendář svátků',
  'sla.bh.saveFirst': 'Nejprve uložte tento kalendář, poté přidejte svátky.',
  'sla.bh.holidayName': 'Název svátku',
  'sla.bh.date': 'Datum',
  'sla.bh.addHoliday': 'Přidat svátek',
  'sla.bh.noHolidays': 'Zatím žádné svátky',
  'sla.bh.noHolidaysHint': 'Výše přidejte svátek s datem, aby byl vyloučen z výpočtů SLA.',
  'sla.bh.remove': 'Odebrat',
  'sla.day.monday': 'Pondělí',
  'sla.day.tuesday': 'Úterý',
  'sla.day.wednesday': 'Středa',
  'sla.day.thursday': 'Čtvrtek',
  'sla.day.friday': 'Pátek',
  'sla.day.saturday': 'Sobota',
  'sla.day.sunday': 'Neděle',

  'set.ftype.single_line_text': 'Jednořádkový text',
  'set.ftype.multi_line_text': 'Víceřádkový text',
  'set.ftype.dropdown': 'Rozbalovací seznam',
  'set.ftype.checkbox': 'Zaškrtávací pole',
  'set.ftype.radio': 'Přepínač',
  'set.ftype.multiselect': 'Vícenásobný výběr',
  'set.ftype.lookup': 'Vyhledávací vztah',
  'set.ftype.dependent': 'Závislé pole',
  'set.ftype.date': 'Datum',
  'set.ftype.number': 'Číslo',
  'set.ftype.decimal': 'Desetinné číslo',
  'set.ftype.desc.lookup': 'Vyberte záznam ze systémového zdroje.',
  'set.ftype.desc.single_line_text': 'Krátká textová hodnota.',
  'set.ftype.desc.multi_line_text': 'Dlouhá textová hodnota.',
  'set.ftype.desc.checkbox': 'Hodnota ano nebo ne.',
  'set.ftype.desc.dropdown': 'Vyberte jednu normalizovanou možnost.',
  'set.ftype.desc.dependent': 'Možnosti závisí na nadřazeném poli.',
  'set.ftype.desc.date': 'Hodnota kalendářního data.',
  'set.ftype.desc.number': 'Hodnota celého čísla.',
  'set.ftype.desc.decimal': 'Hodnota desetinného čísla.',
  'set.src.STATIC': 'Statické možnosti',
  'set.src.AGENTS': 'Agenti',
  'set.src.USERS': 'Uživatelé / Zákazníci',
  'set.src.GROUPS': 'Skupiny',
  'set.src.ROLE': 'Role',
  'set.src.COUNTRIES': 'Země',
  'set.src.CUSTOM': 'Vlastní rozbalovací seznam',
  'set.settings': 'Nastavení',
  'set.ticketFields': 'Pole tiketu',
  'set.ticketForms': 'Formuláře tiketů',
  'set.requestFailed': 'Požadavek se nezdařil. Zkuste to prosím znovu.',
  'set.refresh': 'Obnovit',
  'set.saving': 'Ukládání…',
  'set.saveChanges': 'Uložit změny',
  'set.default': 'Výchozí',
  'set.published': 'Publikováno',
  'set.draft': 'Koncept',
  'set.publish': 'Publikovat',
  'set.unpublish': 'Zrušit publikaci',
  'set.deleteForm': 'Smazat formulář',
  'set.description': 'Popis',
  'set.relationshipSource': 'Zdroj vztahu',
  'set.dependsOn': 'Závisí na: {field}',
  'set.deleteFormTitle': 'Smazat „{name}“?',
  'set.deleteFormDescription': 'Tento formulář tiketu a jeho konfigurace budou trvale smazány.',
  'set.formIdRequired': 'ID formuláře je povinné.',
  'set.formNotFound': 'Formulář tiketu nebyl nalezen.',
  'set.tf.removeOption': 'Odebrat {label}',
  'set.tf.noOptions': 'Zatím nejsou definovány žádné možnosti.',
  'set.tf.addOptionPlaceholder': 'Přidat možnost...',
  'set.tf.add': 'Přidat',
  'set.tf.dependsOnField': 'Závisí na poli',
  'set.tf.selectParent': '— Vyberte nadřazené pole —',
  'set.tf.parentHelp': 'Nadřazené rozbalovací pole, jehož vybraná hodnota určuje dostupné možnosti tohoto pole.',
  'set.tf.optionMappings': 'Mapování možností',
  'set.tf.savingParen': '(ukládání...)',
  'set.tf.mappingsError': 'Mapování se nepodařilo načíst',
  'set.tf.archivedParen': ' (archivováno)',
  'set.tf.mappedCount': 'Namapováno: {count}',
  'set.tf.saveFirst': 'Chcete-li nastavit mapování možností, nejprve pole uložte.',
  'set.tf.newField': 'Nové: {type}',
  'set.tf.pageDescription': 'Spravujte importované definice polí, viditelnost, pravidla povinnosti a pořadí používané ve formulářích tiketů.',
  'set.tf.addField': 'Přidat pole',
  'set.tf.addFieldHelp': 'Přetáhněte typ do seznamu polí nebo použijte Přidat.',
  'set.tf.addType': 'Přidat: {type}',
  'set.tf.registry': 'Registr polí',
  'set.tf.savingOrder': 'Ukládání pořadí…',
  'set.tf.searchAria': 'Hledat pole tiketu',
  'set.tf.searchPlaceholder': 'Hledat podle názvu nebo klíče...',
  'set.tf.filterAria': 'Filtrovat podle typu pole',
  'set.tf.allTypes': 'Všechny typy polí',
  'set.tf.emptyFirstTitle': 'Přidejte své první pole tiketu',
  'set.tf.emptyFirstDesc': 'Přetáhněte typ pole z palety nebo jej vytvořte pomocí Přidat.',
  'set.tf.emptyFilterTitle': 'Těmto filtrům neodpovídají žádná pole',
  'set.tf.emptyFilterDesc': 'Zkuste jiný hledaný výraz nebo rozšiřte filtr typu pole.',
  'set.tf.archived': 'Archivováno',
  'set.tf.dependent': 'Závislé',
  'set.tf.customerVisible': 'Viditelné pro zákazníka',
  'set.tf.internal': 'Interní',
  'set.tf.configuration': 'Konfigurace pole',
  'set.tf.selectTitle': 'Vyberte pole ke konfiguraci',
  'set.tf.selectDesc': 'Vyberte pole z registru a upravte jeho popisky, pravidla a viditelnost.',
  'set.tf.externalId': 'Externí ID: {value}',
  'set.tf.sourceRenderer': 'Zdroj: {source} · Vykreslení: {renderer}',
  'set.tf.optionSource': 'Zdroj možností: {value}',
  'set.tf.dependsOnKey': 'Závisí na: {value}',
  'set.tf.internalLabel': 'Interní popisek',
  'set.tf.customerLabel': 'Popisek pro zákazníka',
  'set.tf.relationshipHelp': 'Určuje, odkud se za běhu načítají hodnoty vyhledávání.',
  'set.tf.validationVisibility': 'Validace a viditelnost',
  'set.tf.requiredAgents': 'Povinné pro agenty',
  'set.tf.requiredCustomers': 'Povinné pro zákazníky',
  'set.tf.requiredClosure': 'Povinné pro uzavření',
  'set.tf.displayedCustomers': 'Zobrazeno zákazníkům',
  'set.tf.customersEdit': 'Zákazníci mohou upravovat',
  'set.tf.customersFilter': 'Zákazníci mohou filtrovat',
  'set.tf.active': 'Aktivní',
  'set.tf.dropdownOptions': 'Možnosti rozbalovacího seznamu ({count})',
  'set.tf.archiveTitle': 'Archivovat „{name}“?',
  'set.tf.archiveDesc': 'Pole se stane neaktivním a nebude dostupné pro nové tikety. Stávající data tiketů zůstanou zachována.',
  'set.tf.archiveField': 'Archivovat pole',
  'set.tf.alreadyArchived': 'Již archivováno',
  'set.tf.archivedNote': 'Archivovaná pole zůstávají dostupná pro historické hodnoty.',
  'set.tfm.systemUser': 'Systém',
  'set.tfm.untitled': 'Formulář bez názvu',
  'set.tfm.pageDescription': 'Vytvářejte opakovaně použitelné formuláře a vyberte, která importovaná pole mohou agenti a zákazníci používat.',
  'set.tfm.newForm': 'Nový formulář',
  'set.tfm.creating': 'Vytváření…',
  'set.tfm.allForms': 'Všechny formuláře',
  'set.tfm.configuredOne': '{count} nakonfigurovaný formulář',
  'set.tfm.configuredMany': 'Nakonfigurované formuláře: {count}',
  'set.tfm.filter': 'Filtr',
  'set.tfm.searchAria': 'Hledat formuláře tiketů',
  'set.tfm.searchPlaceholder': 'Hledat formuláře…',
  'set.tfm.status': 'Stav',
  'set.tfm.allStatuses': 'Všechny stavy',
  'set.tfm.emptyFilterTitle': 'Těmto filtrům neodpovídají žádné formuláře',
  'set.tfm.emptyFilterDesc': 'Zkuste jiný hledaný výraz nebo rozšiřte filtr stavu.',
  'set.tfm.emptyFirstTitle': 'Vytvořte svůj první formulář tiketu',
  'set.tfm.emptyFirstDesc': 'Vytvořte formulář a začněte konfigurovat importovaná pole.',
  'set.tfm.createFirst': 'Vytvořte svůj první formulář',
  'set.tfm.colName': 'Název',
  'set.tfm.colCreatedAt': 'Vytvořeno',
  'set.tfm.colUpdatedBy': 'Naposledy aktualizoval(a)',
  'set.tfm.colUpdatedAt': 'Naposledy aktualizováno',
  'set.tfm.colPortals': 'Přidružené portály',
  'set.tfm.colActions': 'Akce',
  'set.tfm.notConfigured': 'Nenakonfigurováno',
  'set.tfm.actionsFor': 'Akce pro {name}',
  'set.tfm.editForm': 'Upravit formulář',
  'set.tb.section.default.title': 'Výchozí pole',
  'set.tb.section.default.desc': 'Základní pole pracovního postupu podpory importovaná ze zdrojového systému.',
  'set.tb.section.custom.title': 'Vlastní pole',
  'set.tb.section.custom.desc': 'Další pole nakonfigurovaná pro váš proces podpory.',
  'set.tb.section.nested.title': 'Vnořená pole',
  'set.tb.section.nested.desc': 'Závislá pole, jejichž možnosti se řídí nadřazeným polem.',
  'set.tb.discardTitle': 'Zahodit neuložené změny?',
  'set.tb.discardDesc': 'Vaše úpravy tohoto formuláře tiketu nebyly uloženy.',
  'set.tb.leave': 'Odejít bez uložení',
  'set.tb.nameRequired': 'Název formuláře je povinný.',
  'set.tb.saved': 'Formulář byl uložen.',
  'set.tb.nowPublished': 'Formulář byl publikován.',
  'set.tb.nowUnpublished': 'Publikace formuláře byla zrušena.',
  'set.tb.admin': 'Administrace',
  'set.tb.builder': 'Návrhář',
  'set.tb.titleAria': 'Název formuláře',
  'set.tb.defaultLocked': 'Výchozí / uzamčeno',
  'set.tb.previewPortal': 'Náhled na portálu',
  'set.tb.configureTitle': 'Nakonfigurujte pole zahrnutá v tomto formuláři.',
  'set.tb.configureDesc': 'Změny se do databáze centra podpory uloží po výběru Uložit změny. Povinná pole zůstávají zapnutá.',
  'set.tb.formDetails': 'Podrobnosti formuláře',
  'set.tb.formDetailsHelp': 'Použijte srozumitelný popis, aby administrátoři věděli, kdy tento formulář použít.',
  'set.tb.descPlaceholder': 'Popište, kdy se má tento formulář používat…',
  'set.tb.importedFields': 'Importovaná pole',
  'set.tb.importedHelp': 'Přetažením změníte pořadí polí. Přepínačem pole do tohoto formuláře zahrnete nebo vyloučíte.',
  'set.tb.noneInSection': 'V této sekci nejsou žádná importovaná pole.',
  'set.tb.dragReorder': 'Přetažením změníte pořadí',
  'set.tb.required': 'Povinné',
  'set.tb.nested': 'Vnořené',
  'set.tb.enableField': 'Zapnout {label}',
  'set.tb.enabled': 'Zapnuto',
  'set.tb.disabled': 'Vypnuto',
  'set.tb.emptyTitle': 'Zatím nejsou žádná pole ke konfiguraci',
  'set.tb.emptyDesc': 'Importujte pole tiketu a začněte tento formulář sestavovat.',
  'set.tb.deleting': 'Mazání…',
  'set.tp.loadError': 'Náhled formuláře se nepodařilo načíst.',
  'set.tp.preview': 'Náhled',
  'set.tp.customerPreview': 'Náhled pro zákazníka',
  'set.tp.backToBuilder': 'Zpět do návrháře',
  'set.tp.modeTitle': 'Režim náhledu',
  'set.tp.modeDesc': 'Toto je náhled bez odesílání. Všechna zapnutá pole se zobrazují v uloženém pořadí formuláře.',
  'set.tp.emptyTitle': 'Zatím nejsou zapnutá žádná pole',
  'set.tp.emptyDesc': 'Zapněte pole v návrháři formuláře, aby se zobrazila v tomto náhledu.',

  'por.error.generic': 'Požadavek se nepodařilo dokončit.',
  'por.error.requestNotFound': 'Požadavek nebyl nalezen.',
  'por.error.formUnavailable': 'Formulář požadavku není k dispozici.',
  'por.error.articleNotFound': 'Článek nebyl nalezen.',
  'por.error.selectRating': 'Vyberte prosím hodnocení od 1 do 5.',
  'por.tab.all': 'Vše',
  'por.list.title': 'Moje požadavky na podporu',
  'por.list.description': 'Sledujte své požadavky a odpovídejte týmu podpory.',
  'por.list.newRequest': 'Nový požadavek',
  'por.list.knowledgeBase': 'Znalostní báze',
  'por.list.filterByStatus': 'Filtrovat požadavky podle stavu',
  'por.list.searchPlaceholder': 'Hledat podle předmětu…',
  'por.list.count': 'Požadavky: {count}',
  'por.list.countOne': '{count} požadavek',
  'por.list.emptyFilteredTitle': 'Tomuto zobrazení neodpovídají žádné požadavky',
  'por.list.emptyTitle': 'Zatím žádné požadavky',
  'por.list.emptyFilteredDescription': 'Zkuste kartu Vše nebo jiný hledaný výraz.',
  'por.list.emptyDescription': 'Odešlete požadavek a tým podpory se jej ujme.',
  'por.list.submitFirst': 'Odešlete svůj první požadavek',
  'por.col.request': 'Požadavek',
  'por.col.subject': 'Předmět',
  'por.col.status': 'Stav',
  'por.col.priority': 'Priorita',
  'por.col.created': 'Vytvořeno',
  'por.detail.myRequests': 'Moje požadavky',
  'por.detail.reopen': 'Znovu otevřít tento požadavek',
  'por.detail.attachments': 'Přílohy',
  'por.detail.download': 'Stáhnout',
  'por.detail.conversation': 'Konverzace',
  'por.detail.noReplies': 'Zatím žádné odpovědi',
  'por.detail.noRepliesHint': 'Přidejte níže odpověď a tým podpory se jí ujme.',
  'por.detail.reply': 'Odpověď',
  'por.detail.replyPlaceholder': 'Napište odpověď',
  'por.detail.sending': 'Odesílání…',
  'por.detail.sendReply': 'Odeslat odpověď',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Odebrat {name}',
  'por.submit.newRequest': 'Nový požadavek',
  'por.submit.defaultTitle': 'Odeslat požadavek na podporu',
  'por.submit.intro': 'Vyplňte níže uvedená pole a odešlete požadavek.',
  'por.submit.subjectRequired': 'Předmět je povinný',
  'por.submit.descriptionRequired': 'Popis je povinný',
  'por.submit.attachments': 'Přílohy',
  'por.submit.submitting': 'Odesílání…',
  'por.submit.submit': 'Odeslat požadavek',
  'por.kb.portal': 'Portál',
  'por.kb.title': 'Znalostní báze',
  'por.kb.description': 'Najděte odpovědi dříve, než odešlete požadavek.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Výsledky hledání',
  'por.kb.searchPlaceholder': 'Hledat články',
  'por.kb.emptyTitle': 'Zatím nejsou publikovány žádné články',
  'por.kb.emptyDescription': 'Odešlete požadavek a tým podpory vám pomůže přímo.',
  'por.kb.noFolders': 'Žádné složky',
  'por.kb.articles': 'Články: {count}',
  'por.kb.articlesOne': '{count} článek',
  'por.kb.noMatch': 'Pro „{query}“ nebyly nalezeny žádné články',
  'por.kb.folderEmpty': 'V této složce zatím nejsou žádné články',
  'por.kb.noMatchHint': 'Zkuste kratší hledaný výraz nebo místo toho odešlete požadavek.',
  'por.kb.folderEmptyHint': 'Procházejte jinou složku nebo místo toho odešlete požadavek.',
  'por.kb.submitRequest': 'Odeslat požadavek',
  'por.kb.views': 'Zobrazení: {count}',
  'por.kb.thanks': 'Děkujeme za zpětnou vazbu!',
  'por.kb.helpful': 'Pomohlo vám to?',
  'por.kb.yes': 'Ano',
  'por.kb.no': 'Ne',
  'por.csat.thanksTitle': 'Děkujeme za vaši zpětnou vazbu',
  'por.csat.thanksBody': 'Vaše odpověď byla zaznamenána.',
  'por.csat.title': 'Jak jsme si vedli?',
  'por.csat.request': 'Požadavek č. {number}: {subject}',
  'por.csat.rating': 'Hodnocení',
  'por.csat.stars': 'Hvězdičky: {count}',
  'por.csat.comment': 'Komentář',
  'por.csat.submit': 'Odeslat zpětnou vazbu',
  'agents.tempPassword.title': 'Dočasné heslo',
  'agents.tempPassword.help': 'Nastavte tomuto agentovi dočasné heslo. Při příštím přihlášení bude vyzván k zadání nového hesla. Alespoň 12 znaků.',
  'agents.tempPassword.button': 'Nastavit dočasné heslo',
  'agents.tempPassword.saving': 'Nastavuje se…',
  'agents.tempPassword.error': 'Dočasné heslo se nepodařilo nastavit.',
  'ui.showPassword': 'Zobrazit heslo',
  'ui.hidePassword': 'Skrýt heslo',
  'dashboard.awaitingResolutionConfirmation': 'Čeká na potvrzení vyřešení',
  'dashboard.awaitingUserReply': 'Čeká na odpověď uživatele',
  'dashboard.changeRequests': 'Požadavky na změnu',
  'agents.tempPassword.successEmailed': 'Dočasné heslo bylo nastaveno a odesláno agentovi e-mailem.',
  'agents.tempPassword.successNotEmailed': 'Dočasné heslo bylo nastaveno, ale e-mail se nepodařilo odeslat. Sdělte heslo agentovi zabezpečeným kanálem.',
} as const;

export default cs;
